export default {
  zh: {
    // ============================NAVIGATION
    "nav.link1": "关于我们",
    "nav.link2": "联系我们",
    "nav.link3": "媒体介绍",
    "nav.link4": "合作伙伴",
    "nav.link5": "博客",
    "nav.btn": "了解报价",
    "nav.quoting.details": "详细信息",
    "nav.quoting.travellers": "旅行者",
    "nav.quoting.policies": "保单",
    "nav.quoting.purchase": "购买",

    // =========================Homepage
    "home.hero1": "来加拿大探亲访友?",
    "home.hero2": "是否考虑过从加拿大购买您的旅游保险?",
    "home.subcap": "了解一下从加拿大购买旅游保险的几大优势",
    "home.btn1": "了解报价",
    "home.btn2": "查看保单",

    "home.whyCap": "为什么从加拿大购买旅游保险?",
    "home.why1.cap": "直赔功能",
    "home.why1.text": "不用自己掏腰包垫付，医院与保险公司直接理赔。",
    "home.why2.cap": "既往病史",
    "home.why2.text": "有没有想过您的既往病史是否属于理赔范围？",
    "home.why3.cap": "已经在加拿大境内？",
    "home.why3.text": "您可能已经无法从出发国购买保险。不用担心。。。",

    "home.fewCap": "只需点击几下鼠标就可让你的旅途后顾无忧",
    "home.few1": "告诉我们您的行程. 我们要的并不多",
    "home.few2": "比较不同的产品和价格. 选择最适合你的",
    "home.few3": "在线支付, 几分钟之内通过邮件收到保单",
    "home.fewbtn": "开始报价",

    "home.purposeSub": "您的旅行目的可能会影响您对旅游保险的选择",
    "home.purposeCap": "来加拿大旅行的目的（举例说明）?",
    "home.purpose1": "户外探险",
    "home.purpose1.text":
      "你可能需要额外的针对极限（接触性）运动的附加保障，因为某些计划中可能不包含这部分保障。",
    "home.purpose2": "探亲访友",
    "home.purpose2.text":
      "对于父母和祖父母来说，购买既往病史的保障是非常有必要的。在选择保险计划时请留意不同计划对于既往病史的定义和保障范围。",
    "home.purpose3": "学生或陪读家庭成员",
    "home.purpose3.text":
      "全职的留学生可以考虑购买留学生保险，它的保障范围和保费更具优势。",
    "home.purpose4": "工作",
    "home.purpose5": "新移民",
    "home.purpose6": "其他",
    "home.purpose4.text":
      "如果您不确定要在加拿大停留多长时间，建议购买较长的时间范围以避免在续保时因为某些原因被拒保或保费增加。",

    "home.partner": "我们合作的保险公司",

    "home.vidsup": "为什么从加拿大购买旅游保险？",
    "home.vidcap": "通过短视频了解更多",

    "home.reviewcap": "听听我们的客户怎么说",
    "home.review1n": "Elizabeth",
    "home.review1t":
      "iWare Travel专业的服务和全面的旅游保险让我轻松享受在加拿大的旅途，没有后顾之忧。谢谢你，Lancy，下次也会从你这里购买产品。",
    "home.review2n": "Cathy Liu",
    "home.review2t":
      "我从iWare Travel为我的妈妈和姐姐一家购买了旅游保险。非常好的服务，值得信赖。",
    "home.review3n": "Shengzhu Zhang",
    "home.review3t":
      "我是卡尔加里大学的一名访学老师，从Ware Travel为我和我的家人购买了三份保单。他们总是耐心的解答我所有的问题并且推荐最适合我们的保险产品。",

    "home.reachoutcap": "想要联系我们？",
    "home.reachout": "我们希望听到你的声音",
    "home.reachoutbtn": "联系我们",

    // =========================footer
    "foot.license": "iWare Travel Insurance is licensed by",
    "foot.resources": "资源",
    "foot.resources1": "联系我们",
    "foot.resources2": "获取报价",
    "foot.legal": "法律",
    "foot.terms": "使用条款",
    "foot.licenses": "执照",
    "foot.copyright": "© 2020 iWareTravel.ca. All rights reserved.",
    "foot.btn": "获取报价",

    // ========================main buttons
    "btn.continue": "下一步",
    "btn.goback": "上一步",
    "btn.compareplans": "比较保障范围",
    "btn.buy": "下单",
    "btn.wording": "保单条款",
    "btn.eligible": "我符合条件",
    "btn.notEligible": "我不符合条件",
    "btn.yes": "是",
    "btn.no": "否",
    "btn.confirm": "我确认",
    "btn.understand+eligible": "我理解并确认我符合条件",
    "btn.change": "修改",
    "btn.edit": "编辑",
    "btn.purchase": "下单",
    "btn.return": "返回",
    "btn.send": "发送",
    "btn.submit": "提交",
    "btn.renew": "Renew",
    Yes: "是",
    No: "否",
    "btn.yestoall": "确认全部内容",
    "btn.close": "关闭",
    "btn.updateQuote": "更新报价",

    // =========================stepper
    "stp.details": "旅行计划",
    "stp.travellers": "旅行者",
    "stp.policies": "保险计划",
    "stp.purchase": "购买",

    // =========================get-my-quote-detials
    "details.title": "您的旅行计划",
    "details.purpose": "来加拿大干点啥",
    "details.purposeHelp": "这个信息可以帮助我们找到最适合您的保险计划",
    "details.from": "出发地",
    "details.to": "目的地",
    "details.start": "保单生效日期",
    "details.end": "保单失效日期",
    "details.arrival": "到达目的地日期",
    "details.applied": "申请日期（今日日期）",
    "details.choose": "请选择",
    "details.studentTravel": "该留学生保险计划将在您不再是加拿大全职学生那天起的60天后失效，请据此选择相应的保单失效日期",
    "details.studentTravelLinkText": "具体细节，请查看保单条款",
    "details.studentLabel": "学生",
    "details.studentCoverge": "仅适用于2百万的保障额度",

    // =========================get-my-quote-travellers
    "travellers.title": "旅行者",
    policyholder: "保单持有人",
    "travellers.holderfname": "名",
    "travellers.holderlname": "姓",
    "travellers.holderdob": "出生日期",
    "travellers.holdergender": "性别",
    female: "女",
    male: "男",
    extra: "您是否需要额外的运动保险?",
    extraSub: "（仅适用于Tugo的保险计划）",
    extraTripInterruption: "您需要行程中断保障吗？",
    extraTripInterruptionCancellation: "您需要行程取消/行程中断保障吗", 
    
    "traveller.add": "添加同行旅行者",
    "generic.traveller": "旅行者",
    "relationship.placeholder": "与保单持有人的关系",

    spouse: "配偶",
    dependant: "子女",
    other: "其他",

    // ===============================get-my-quote-policies

    "policies.title": "您的保险计划",
    "policies.coverage": "保障范围:",
    "policies.deductible": "自负额:",
    "policies.preexisting": "既往病史保障:",

    // ------------------------------plan-card
    "plan.compare": "比较",
    "plan.items": "保障项目",
    "plan.medical": "紧急医疗情况",
    "plan.comparebenefits": "比较保障范围",
    "plan.notice1": "对80岁以上的人群，只有Tugo的保险计划",
    "plan.notice2": "对需要额外运动保险的人群，只有Tugo的保险计划",
    "plan.includePre": "保险计划均包含既往病史。",
    "plan.unavail": "没有找到相应计划。",
    "coverage.items": "保险内容",
    "coverage.policyPeriod": "保单时效",
    "medical emergency": "紧急医疗",
    "pre-existing conditions": "既往病史",

    "plan.medicalGMS": "在旅行中发生的突发或紧急状况并需要立即就医的。",
    "plan.medicalTugo":
      "不可预见的急病或意外受伤，需要紧急就医以减轻对生命或健康的威胁。",
    "plan.medicalDestin":
      "在受保期间发生的突发的、不可预见的急病或意外受伤，需要得到医生或牙医的紧急处理并且不能被合理拖延的。",

    "plan.pre": "既往病史",
    "gms.pre-existing conditions": `您曾经接受过治疗或问诊的医疗状况; 以及/或者 <br>
		b. 之前已经出现症状的，虽然未经诊断但接受过医疗处理或问询的医疗状况`,
    "tugo.pre-existing conditions": `a) 在行程开始前已经被诊断的牙齿或其他医疗状况、疾病或受伤，并且已经问询或接受过治疗; 或者, <br>
		b) 在行程开始前已经出现症状的牙齿或其他医疗状况、疾病或受伤，未经诊断的。; 或者, <br>
    c) 已经确认的牙齿或其他医疗状况、疾病或受伤的并发症或复发，不论在行程开始前是否已有诊断。`,
    "destination.pre-existing conditions": `以下疾病、受伤或其他医疗状况，无论是否有医生诊断。: <br>
    i) 已经出现症状或特征的; 或者 <br>
    ii) 已经问询或接受过医疗咨询的; 并且 <br>
    iii) 在保单生效之前已经存在的`,

    "tugo.trip-cancellation-interruption-label": "请选择出发前发生的行程取消/中断的保额",
    "tugo.trip-cancellation-interruption-description": "包括被保险人在出发前取消行程或者行程被迫中断所发生的费用，请选择最接近已经预付的费用的金额",
    "tugo.trip-interruption-label": "请选择出发后发生的行程中断的保额",
    "tugo.trip-interruption-description": "包括在被保险人的行程被迫中断的情况下所发生的不可预期的费用",

    "tugoStudent.pre-existing conditions": `a) 在行程开始前已经被诊断的牙齿或其他医疗状况、疾病或受伤，并且已经问询或接受过治疗; 或者, <br>
		b) 在行程开始前已经出现症状的牙齿或其他医疗状况、疾病或受伤，未经诊断的。; 或者, <br>
    c) 已经确认的牙齿或其他医疗状况、疾病或受伤的并发症或复发，不论在行程开始前是否已有诊断。`,
    "destination.pre-existing conditions": `以下疾病、受伤或其他医疗状况，无论是否有医生诊断。: <br>
    i) 已经出现症状或特征的; 或者 <br>
    ii) 已经问询或接受过医疗咨询的; 并且 <br>
    iii) 在保单生效之前已经存在的`,

    "gms.medical emergency": "旅途中突发紧急情况需要立即采取行动的。",
    "tugo.medical emergency":
      "不可预见的急病或受伤，并且需要紧急医疗治疗以减轻对生命或健康的威胁。",
    "tugoStudent.medical emergency":
      "不可预见的急病或受伤，并且需要紧急医疗治疗以减轻对生命或健康的威胁。",
    "destination.medical emergency":
      "在保障期间内突发的、不可预见的急病或受伤，并且不能被延误，需要医生或有执照的牙医紧急救治的。",

    "plan.triplength": "行程时间",
    "plan.triplengthUnit": "天",

    // -------------------------Compare Benefits
    "benefits.title": "比较保障福利",
    "all coverages": "投保金额",
    "all deductibles": "免赔额",
    "age limit": "年龄限制",
    "Covid-19 coverage": "新冠的保障",
    "drugs or medications": "药物",
    "emergency hospital": "紧急住院",
    "Paramedical Services": "辅助治疗",
    "follow-up visits": "后续就医",
    Repatriation: "遣返",
    "dental emergency": "紧急牙医",
    "Accidental Death & Dismemberment": "意外死亡和残疾",
    "Waiting period": "等待期",

    "Pre-existing medical conditions": "既往病史",
    "Pre-existing conditions coverage age limit": "既往病史保障年龄限制",
    Maternity: "怀孕保障",
    "Optional non-medical coverage": "可选择的非医疗保障",
    "benefits.disclaimer":
      "提示: 以上只是关于保障内容的摘要,详情请仔细阅读保单条款",

    // =========================destination benefits

    "all coverages.destination":
      "$10,000 - $25,000 - $50,000 - $100,000 - $150,000 or $300,000",
    "all deductibles.destination":
      "$0 - $250 - $500 - $1,000 - S2,500 - $5,000 - $10,000",
    "age limit.destination": "无",
    "Covid-19 coverage.destination": "提供,但不包括加拿大以外的行程",
    "drugs or medications.destination": "不超过$1,000 并且不超过30天的剂量",
    "emergency hospital.destination": "半私人病房",
    "Paramedical Services.destination": "不超过500加币每种辅助治疗",
    "follow-up visits.destination": "不超过3,000加币",
    "Repatriation.destination": "不超过3,000加币的单程经济舱运送",
    "dental emergency.destination":
      "不超过3,000加币 用于治疗面部意外击打, 不超过500加币的止痛费用",
    "Accidental Death & Dismemberment.destination":
      "不超过投保总金额并且最高不超过150,000加币",
    "Waiting period.destination":
      "如果本计划是在抵达加拿大后购买的,针对疾病的情况有48小时的等待期(适用于85岁及以下人群)。对于86岁以及以上人群, 等待期为15天。",
    "Pre-existing medical conditions.destination":
      "对于选择既往病史保障的79岁以及以下人群,要求有120天的稳定期",
    "Pre-existing conditions coverage age limit.destination": "79岁及以下",
    "Maternity.destination": "无保障",
    "Optional non-medical coverage.destination": "无",

    // =========================gms benefits

    "all coverages.gms": "$25,000 - $50,000 - $100,000 - $150,000",
    "all deductibles.gms": "$0 - $100 - $500 - $1,000",
    "age limit.gms": "低于80岁",
    "Covid-19 coverage.gms": "提供",
    "drugs or medications.gms": "不超过30天的处方药",
    "emergency hospital.gms": "半私人病房",
    "Paramedical Services.gms": "不超过300加币",
    "follow-up visits.gms": "保障持续到紧急医疗状况结束",
    "Repatriation.gms": "不超过5,000加币将您运送回国",
    "dental emergency.gms": "不超过5,000加币的费用将您运送回国",
    "Accidental Death & Dismemberment.gms": "无",
    "Waiting period.gms":
      "如果本计划是在抵达加拿大后30天内购买的,有两天的等待期。如果超过30天,则有7天的等待期。",
    "Pre-existing medical conditions.gms":
      "在保单生效前180天内发生的稳定的既往病史",
    "Pre-existing conditions coverage age limit.gms": "79岁及以下",
    "Maternity.gms": "无保障",
    "Optional non-medical coverage.gms": "无",

    // =========================tugo benefits

    "all coverages.tugo":
      "$10,000 - $25,000 - $50,000 - $100,000 - $200,000 or $300,000",
    "all deductibles.tugo":
      "$0 - $150 - $500 - $1,000 - $2,500 - S5,000 - $10,000",
    "age limit.tugo": "无",
    "Covid-19 coverage.tugo": "提供,包括加拿大以外的行程",
    "drugs or medications.tugo": "不超过30天的处方药",
    "emergency hospital.tugo": "半私人病房",
    "Paramedical Services.tugo": "不超过600加币每种辅助治疗",
    "follow-up visits.tugo": "在14天内不超过5次",
    "Repatriation.tugo": "不超过投保额度的范围内将遗体运送回国",
    "dental emergency.tugo":
      "不超过6,000加币用于治疗面部意外击打,不超过600加币用于治疗其他紧急情况",
    "Accidental Death & Dismemberment.tugo":
      "⻜机以及其他公共交通方式不超过100,000加币,24小时意外不超过25,000加币",
    "Waiting period.tugo":
      "如果本计划是在抵达加拿大后60天内购买,针对疾病有48小时的等待期。如果超过60天购买,则有7天的等待期。",
    "Pre-existing medical conditions.tugo":
      "对于59岁以及以下人群,既往病史的稳定期要求是120天。对于60至69岁人群,既往病史的稳定期要求是180天。70岁以上人群,稳定期为365天。",
    "Pre-existing conditions coverage age limit.tugo": "无年龄限制",
    "Maternity.tugo": "不超过6000加币的产前、生产和/或并发症",
    "Optional non-medical coverage.tugo": "运动保障",

    // =========================tugo benefits

    "all coverages.tugoStudent":
      "$2,000,000",
    "all deductibles.tugoStudent":
      "$0",
    "age limit.tugoStudent": "不超过69岁",
    "Covid-19 coverage.tugoStudent": "是的，包括加拿大以外的旅行保障（只要在加拿大的时间超过总行程的50%）",
    "drugs or medications.tugoStudent": "不超过30天的供应量和10,000加币",
    "emergency hospital.tugoStudent": "半私人病房",
    "Paramedical Services.tugoStudent": "每类专业医师不超过600加币",
    "follow-up visits.tugoStudent": "在14天内不超过5次复诊",
    "Repatriation.tugoStudent":
      "遣返遗体不超过25，000加币，在死亡地埋葬的金额不超过5，000加币",
    "dental emergency.tugoStudent":
      "不超过5，000加币的因意外撞击造成的牙齿受伤，以及不超过600加币的牙痛治疗",
    "Accidental Death & Dismemberment.tugoStudent":
      "10，000加币。可选择的额外额度：航空等公共交通意外保障10万加币，24小时意外保障25，000加币",
    "Waiting period.tugoStudent": "---",
    "Pre-existing medical conditions.tugoStudent":
      "覆盖在保单生效日前的90天内稳定的既往病史", 
    "Pre-existing conditions coverage age limit.tugoStudent": "不超过69岁", 
    "Maternity.tugoStudent": "不超过25，000加币，只要受孕是在保障期内发生的", 
    "Optional non-medical coverage.tugoStudent": "运动和活动保障",

    // =========================plan purchase
    "purchase.title2": "需要确认的重要信息",

    // -------------------------gms plan
    "gms.under55": "如果您不超过55岁，具备以下任何一种情况将不适用本计划:",
    "gms.under55content1":
      "1. 您有任何理由需要寻求医疗(不包括慢性病常规治疗或为获取旅行签证所要求的体检)",
    "gms.under55content2":
      "2. 如果您目前在加拿大，您曾经遭到过其他加拿大保险公司提供的类似险种的拒保; 并且",
    "gms.under55content3":
      "3. 如果您目前在加拿大，在过去12个月内，您在加拿大的医疗费用超过5,000加币",

    "gms.55orOlder": "如果您超过55岁，具备以下任何一种情况将不适用本计划:",
    "gms.55orOlderContent1": "1. 在保单生效日已经80岁或以上;",
    "gms.55orOlderContent2":
      "2. 您是否有任何理由需要寻求医疗(不包括慢性病常规治疗或 为获取旅行签证所要求的体检)?",
    "gms.55orOlderContent3":
      "3. 如果您目前在加拿大，您是否曾经遭到过其他加拿大保险公司提供的类似险种的拒保?",
    "gms.55orOlderContent4":
      "4. 如果您目前在加拿大，在过去12个月内，您在加拿大的医疗费用超过5,000加币",
    "gms.55orOlderContent5": "5. 您患有预计需要医疗的心脏病;",
    "gms.55orOlderContent6": "6. 您在等待疑似心脏疾病的检验结果；",
    "gms.55orOlderContent7":
      "7. 您正在服用治疗心脏病的处方药，同时还在使用治疗糖尿病的胰岛素",
    "gms.55orOlderContent8":
      "8. 您植入过埋藏式复律除颤器(ICD)，需要日常生活协助（适用于70岁及以上人群）",
    "gms.55orOlderContent9": "9. 您有超过一次昏厥的经历且未经过医疗诊断(晕厥)",
    "gms.55orOlderContent10": "10. 您的医疗病况需要家用吸氧设备",
    "gms.55orOlderContent11": "11. 您服用口服类固醇治疗肺病",
    "gms.55orOlderContent12": "12. 您正在接受癌症治疗或者患有转移性的癌症",
    "gms.55orOlderContent13": "13. 您患有未经过手术处理的血管动脉瘤",
    "gms.55orOlderContent14":
      "14. 您做过:<br>a. 瓣膜置换手术; <br>b. 肾透析，或<br>c. 器官移植手术",
    "gms.55orOlderContent15":
      "15. 在过去十二(12)个月内，对于下列疾病，您被诊断患有，或接受新的医疗方案(例如会诊、检测或处方药物)，或更改医疗方案(例如停止、开始服用处方药物或改变服用处方药 物的剂量，不包括香豆素(Coumadin)或华法林(Warfarin) 的剂量变化):<br>a. 充血性心力衰竭<br>b. 心房扑动<br>c. 心房/心室纤维性颤动<br>d. 周围性血管疾病<br>e. 不治之症<br>f. 血栓<br>g. 胃肠道出血",
    "gms.55orOlderContent16":
      "16. 如果您年满70岁及以上并且需要另一个人协助日常起居的。",

    "gms.loc": "您目前是否在加拿大境内?",
    "gms.inCA1": "我购买此计划以取代现有的加拿大健康保险计划.",
    "gms.inCA2": "我截至目前在加拿大境内不超过30天并且没有任何加拿大健康保险",
    "gms.inCA3": "我截至目前在加拿大境内超过30天并且没有任何加拿大健康保险",

    "gms.declaration": `我/我们("本人”)在此声明以上陈述是真实完整的，应构成本人保障申请的一部分。 本人在此授权相关医生、健康服务提供者、其他相关个人、医院、机构、或保险公司可以向Group Medical Services和/或其授权代理、代表、关联机构或其他服务提供者（统称GMS）披露 关于本人医疗历史、症状、治疗、检查、诊断和/或针对本人或在此列示的子女所提供的其他服务。 
    <br>为了便于GMS的保障、产品或服务（统称"保障”）管理，和/或判断保障的适用性，本人在此授权GMS可以: (a) 收集、储存以及使用本人提供给GMS的任何个人信息或者根据b条款所获取的个人信息; 和/或 (b)从或者向以下机构获取或披露关于本人（或在此列示的其他人）的个人信息：政府健康保险计划，医院，诊所，或其他医疗服务机构，医生或其他医疗服务提供者，保险公司，或者其他被合理要求提供上述服务的服务提供商或第三方 。<br> 本人保证我以及在此列示的所有人，除在此提供的信息以外，都没有从其他保险公司获得任何额外保障。如果本人或在此列示的其他人，在受保期间，从其他保险公司获取了额外保障，本人将立即以书面形式通知GMS。本人在此授权GMS可以与本人投保的其他保险公司协调相关费用。 
    <br>本人理解，不论在申请前后，任何虚假陈述、不实或隐瞒信息或申请信息不完整，都可能导致保障失效。本人承诺，如果是代人签署，我有相关人士的授权并且确认上述声明和授权都是经过其本人许可的。`,

    "btn.gms.eligibleI": "我符合条件",
    "btn.gms.eligibleWe": "我们符合条件",
    "gms.declare.title": "声明",
    "gms.inCA.replace.cap": "现有的加拿大健康保险",
    "gms.inCA.replace.company": "保险公司",
    "gms.inCA.replace.policyNum": "保单号",
    "gms.inCA.replace.expiryDate": "保险失效日期",
    "gms.inCA.lessThan30": "在保险生效日期的两日后，您才能申请赔偿。",
    "gms.inCA.moreThan30": "在保险生效日期的七日后，您才能申请赔偿。",

    // -------------------------Tugo

    // -------------------------Tugo

    "tugo.mq.heading": "医疗问卷",
    "tugo.mq.sub": "根据您的年龄，我们需要了解一些您过去医疗以及健康的信息🙂",
    "tugo.mq.q1": "1. 在过去12个月内，您是否有任何以下情况：",
    "tugo.mq.q1.a1": "心肌梗塞或心脏病发作",
    "tugo.mq.q1.a2": "短暂性脑缺血发作或中风",
    "tugo.mq.q1.a3": "用于心血管疾病的动脉分流，血管成形术和/或支架的放置",
    "tugo.mq.q1.a4": "没有",
    "tugo.mq.q2": "2. 在过去12个月内，您是否有任何以下情况：",
    "tugo.mq.q2.description":
      "如果在所指定时间范围内发生过下列任何情况，请选择，无论是否接受过治疗。<br>包括通过药物或医疗设备、饮食或运动得到控制的情况。",
    "tugo.mq.q2.a1": "心房颤动",
    "tugo.mq.q2.a2": "需要注射胰岛素的糖尿病",
    "tugo.mq.q2.a3": "肝疾，肝癌除外",
    "tugo.mq.q2.a4": "肺炎",
    "tugo.mq.q2.a5": "冠状动脉疾病",
    "tugo.mq.q2.a6": "动脉硬化",
    "tugo.mq.q2.a7": "慢性阻塞性肺疾病（COPD），包括不需要家庭供氧的肺气肿",
    "tugo.mq.q2.a8": "哮喘",
    "tugo.mq.q2.a9": "没有",
    "tugo.mq.q3":
      "3. 在过去12个月内，是否使用过烟草产品，或任何尼古丁产品（包括电子香烟）",
    "tugo.mq.q3.a1": "是",
    "tugo.mq.q3.a2": "否",
    "tugo.mq.disclaimer.header": "声明",
    "tugo.mq.disclaimer.content": `请如实回答医疗问卷，这非常重要。如果您符合购买本保险的条件，但是您或您的代理人没有准确回答上述问题，将在您已经选择的免赔额（需要自付的部分）以外，额外支付15，000加币的免赔额。
    在申请理赔时，如果上述问卷的回答不完整或不准确，理赔将不被受理直到您如实作答。在某些适用的情况下，有可能需要支付额外的保费。`,

    "tugo.firstEligibility.cap": "请阅读并确认以下陈述",
    "tugo.firstEligibility1": `如果您已经离开你的母国，请仔细阅读并确认下述陈述。只有当您如实回答“确认全部内容”的时候，才可获得相应的保障。如果您的回答失实，您的保障可能会被废止。<br /><br />如果您在购买时仍在您的母国，请回答“确认全部内容”以绕开这些问题。`,
    "tugo.firstEligibility2": `1. 我当前没有出现任何症状`,
    "tugo.firstEligibility3": `2. 我当前没有任何医疗需求`,
    "tugo.firstEligibility4": `3. 我在抵达加拿大后（或者，如果您是在保险申请日开始的182天以后抵达加拿大的，那么，请确认在过去的182天内含182天）没有看过医生和/或其他医疗服务人员。`,
    "tugo.firstEligibility5": `如果本保险计划是在您抵达加拿大之后购买的，则对于急病相关的理赔可能会有等待期。具体事宜，请仔细阅读保险条款。`,

    "tugo.eligibility.header": "被保资格声明",
    "tugo.eligibility.cap": "如果符合下列条件，您具备申请本保险的资格：",
    "tugo.eligibility.content1": "1. 您没有任何理由需要就医",
    "tugo.eligibility.content2": `2. 您是<br>a) 持有合法身份在加拿大工作的外国劳工，学习的国际留学生或者来访的游客，或者
<br>b) 等待获得省政府医疗的新移民，或者
  <br>c) 在离开较长时间后返回加拿大的加拿大居民，符合享受省政府医疗的资格，但还没有取得医疗卡的。`,
    "tugo.eligibility.content3": "3. 您没有违背医嘱旅行",
    "tugo.eligibility.content4": "4. 您没有被诊断患有不治之症",
    "tugo.eligibility.content5": "5. 您没有接受或被建议进行宁养疗护",
    "tugo.eligibility.content6":
      "6. 您没有慢性阻塞性肺疾病，包括需要家庭供氧的肺气肿",
    "tugo.eligibility.content7":
      "7. 您没有已经转移或需要骨髓移植的胰腺癌、肝癌或其他类型的癌症",
    "tugo.eligibility.content8": "8. 您没有需要透析治疗的肾疾",
    "tugo.eligibility.content9": "9. 您没有进行过或正在等待进行器官移植",
    "tugo.eligibility.content10":
      "10. 您没有被诊断有充血性心力衰竭也称为肺水肿",

    "tugo.finalConfirmation": `<b>重要信息<b> <br>本文件不代表保险条款的全部，我们建议您阅读保单以获取关于保障和除外责任的全部信息。 <br><u>适用于所有保险产品<u> <br>• 您理解在本申请中披露的相关病症可能不在保险范围内，具体既往病史的解释请阅读保险条款。 <br>• 您可能适用某项既往病史的除外责任。请仔细阅读保险条款中关于既往病史的信息。 <br>• 您在此授权相关医院、医生或其他拥有或了解您健康和医疗记录信息的单位和个人，向保险条款中所注明的公司以及TUGO的理赔部门提供该信息，并且授权该公司和TUGO的理赔部门使用和披露该信息以确定该理赔是否在保单的保障范围内。 <br>• 如果理赔涉及到入院治疗，请立即致电TUGO的理赔部门。 <br><tab>加拿大以及美国：1-800-663-0399<tab> <br><tab>墨西哥: 001-800-514-9976<tab> <br><tab>全球: 604-278-4108<tab> <br>• 您或您的代理人同意TUGO以及TUGO的理赔部门收集、使用和披露您的个人信息用于审批您的保险申请、确认保障范围和项目、理赔以及告知关于TUGO和其关联公司提供的其他产品和服务信息。您已经阅读并同意TUGO的保密条款，可以在以下网址获取 https://www.tugo.com/en/privacy/ <br>• 您或许已经从其他保险公司或渠道（比如信用卡公司或健康保险）获得了旅游保险。但是，请注意那未必可以提供您所需要的保障。 <br>• 如果您不具备所选择保险产品的资格要求，本保单将视同无效。如果在申请时提供的信息有任何虚假陈述或隐瞒，本保单将视同无效。<br><u>适用于紧急医疗保险<u> <br>• 您确认当下没有出现症状 <br>• 您理解如果在抵达加拿大后购买本保险，针对疾病发生的理赔可能会有等待期。关于等待期的具体信息，请阅读保单条款。 <br><u>以下适用于行程取消和中断附加险，以及行程中断附加险<u> <br>• 您确认当前没有任何已知情况可能会导致行程的取消 <br>您已经阅读保单中的相关条款和条件并且您本人和您代为申请保险的所有人都理解和同意这些条款和条件`,

    "tugo.terms.cap": "使用条款和条件",

    "tugo.optional.cover.cap": "可选保障",
    "tugo.optional.cover.cat": ["运动和活动保障", "意外死亡和残疾险"],
    "tugo.optional.cover.sport.age": "适用于21岁及以上的被保险人",

    // -------------------------Tugo Student

    "tugoStudent.mq.heading": "医疗问卷",
    "tugoStudent.mq.sub": "根据您的年龄，我们需要了解一些您过去医疗以及健康的信息🙂",
    "tugoStudent.mq.q1": "1. 在过去12个月内，您是否有任何以下情况：",
    "tugoStudent.mq.q1.a1": "心肌梗塞或心脏病发作",
    "tugoStudent.mq.q1.a2": "短暂性脑缺血发作或中风",
    "tugoStudent.mq.q1.a3": "用于心血管疾病的动脉分流，血管成形术和/或支架的放置",
    "tugoStudent.mq.q1.a4": "没有",
    "tugoStudent.mq.q2": "2. 在过去12个月内，您是否有任何以下情况：",
    "tugoStudent.mq.q2.description":
      "如果在所指定时间范围内发生过下列任何情况，请选择，无论是否接受过治疗。<br>包括通过药物或医疗设备、饮食或运动得到控制的情况。",
    "tugoStudent.mq.q2.a1": "心房颤动",
    "tugoStudent.mq.q2.a2": "需要注射胰岛素的糖尿病",
    "tugoStudent.mq.q2.a3": "肝疾，肝癌除外",
    "tugoStudent.mq.q2.a4": "肺炎",
    "tugoStudent.mq.q2.a5": "冠状动脉疾病",
    "tugoStudent.mq.q2.a6": "动脉硬化",
    "tugoStudent.mq.q2.a7": "慢性阻塞性肺疾病（COPD），包括不需要家庭供氧的肺气肿",
    "tugoStudent.mq.q2.a8": "哮喘",
    "tugoStudent.mq.q2.a9": "没有",
    "tugoStudent.mq.q3":
      "3. 在过去12个月内，是否使用过烟草产品，或任何尼古丁产品（包括电子香烟）",
    "tugoStudent.mq.q3.a1": "是",
    "tugoStudent.mq.q3.a2": "否",
    "tugoStudent.mq.disclaimer.header": "声明",
    "tugoStudent.mq.disclaimer.content": `请如实回答医疗问卷，这非常重要。如果您符合购买本保险的条件，但是您或您的代理人没有准确回答上述问题，将在您已经选择的免赔额（需要自付的部分）以外，额外支付15，000加币的免赔额。
    在申请理赔时，如果上述问卷的回答不完整或不准确，理赔将不被受理直到您如实作答。在某些适用的情况下，有可能需要支付额外的保费。`,

    "tugoStudent.firstEligibility.cap": "请阅读并确认以下陈述",
    "tugoStudent.firstEligibility1": `如果在您购买本产品的时候已经离开了您的母国，并且在离开后就过医或者正在经历新的症状或症状恶化，对于这些医疗状况和症状以及相关的状况和症状或由此引发的状况和症状是没有保险保障的。`,
    "tugoStudent.firstEligibility2": `1. 我当前没有出现任何症状`,
    "tugoStudent.firstEligibility3": `2. 我当前没有任何医疗需求`,
    "tugoStudent.firstEligibility4": `3. 我在抵达加拿大后（或者，如果您是在保险申请日开始的182天以后抵达加拿大的，那么，请确认在过去的182天内含182天）没有看过医生和/或其他医疗服务人员。`,
    "tugoStudent.firstEligibility5": `如果本保险计划是在您抵达加拿大之后购买的，则对于急病相关的理赔可能会有等待期。具体事宜，请仔细阅读保险条款。`,

    "tugoStudent.eligibility.header": "被保资格声明",
    "tugoStudent.eligibility.cap": "如果符合下列条件，您具备申请本保险的资格：",
    "tugoStudent.eligibility.content1": "1. 您没有任何理由需要就医",
    "tugoStudent.eligibility.content2": `2. 您是<br>a) 持有合法身份在加拿大工作的外国劳工，学习的国际留学生或者来访的游客，或者
<br>b) 等待获得省政府医疗的新移民，或者
  <br>c) 在离开较长时间后返回加拿大的加拿大居民，符合享受省政府医疗的资格，但还没有取得医疗卡的。`,
    "tugoStudent.eligibility.content3": "3. 您没有违背医嘱旅行",
    // "tugoStudent.eligibility.content4": "4. 您没有被诊断患有不治之症",
    // "tugoStudent.eligibility.content5": "5. 您没有接受或被建议进行宁养疗护",
    // "tugoStudent.eligibility.content6":
    //   "6. 您没有慢性阻塞性肺疾病，包括需要家庭供氧的肺气肿",
    // "tugoStudent.eligibility.content7":
    //   "7. 您没有已经转移或需要骨髓移植的胰腺癌、肝癌或其他类型的癌症",
    // "tugoStudent.eligibility.content8": "8. 您没有需要透析治疗的肾疾",
    // "tugoStudent.eligibility.content9": "9. 您没有进行过或正在等待进行器官移植",
    // "tugoStudent.eligibility.content10":
    //   "10. 您没有被诊断有充血性心力衰竭也称为肺水肿",

    "tugoStudent.finalConfirmation": `<b>重要信息<b> <br>本文件不代表保险条款的全部，我们建议您阅读保单以获取关于保障和除外责任的全部信息。 <br><u>适用于所有保险产品<u> <br>• 您理解在本申请中披露的相关病症可能不在保险范围内，具体既往病史的解释请阅读保险条款。 <br>• 您可能适用某项既往病史的除外责任。请仔细阅读保险条款中关于既往病史的信息。 <br>• 您在此授权相关医院、医生或其他拥有或了解您健康和医疗记录信息的单位和个人，向保险条款中所注明的公司以及TUGO的理赔部门提供该信息，并且授权该公司和TUGO的理赔部门使用和披露该信息以确定该理赔是否在保单的保障范围内。 <br>• 如果理赔涉及到入院治疗，请立即致电TUGO的理赔部门。 <br><tab>加拿大以及美国：1-800-663-0399<tab> <br><tab>墨西哥: 001-800-514-9976<tab> <br><tab>全球: 604-278-4108<tab> <br>• 您或您的代理人同意TUGO以及TUGO的理赔部门收集、使用和披露您的个人信息用于审批您的保险申请、确认保障范围和项目、理赔以及告知关于TUGO和其关联公司提供的其他产品和服务信息。您已经阅读并同意TUGO的保密条款，可以在以下网址获取 https://www.tugo.com/en/privacy/ <br>• 您或许已经从其他保险公司或渠道（比如信用卡公司或健康保险）获得了旅游保险。但是，请注意那未必可以提供您所需要的保障。 <br>• 如果您不具备所选择保险产品的资格要求，本保单将视同无效。如果在申请时提供的信息有任何虚假陈述或隐瞒，本保单将视同无效。<br><u>适用于紧急医疗保险<u> <br>• 您确认当下没有出现症状 <br>• 您理解如果在抵达加拿大后购买本保险，针对疾病发生的理赔可能会有等待期。关于等待期的具体信息，请阅读保单条款。 <br><u>以下适用于行程取消和中断附加险，以及行程中断附加险<u> <br>• 您确认当前没有任何已知情况可能会导致行程的取消 <br>您已经阅读保单中的相关条款和条件并且您本人和您代为申请保险的所有人都理解和同意这些条款和条件`,

    "tugoStudent.terms.cap": "使用条款和条件",

    "tugoStudent.optional.cover.cap": "可选保障",
    "tugoStudent.optional.cover.cat": ["运动和活动保障", "意外死亡和残疾险"],
    "tugoStudent.optional.cover.sport.age": "适用于21岁及以上的被保险人",

    None: "取消",
    "Backcountry Skiing/Snowboarding": "偏远地区滑雪/单板滑雪",
    Boxing: "拳击",
    "Downhill Freestyle Skiing/Snowboarding in Organized Competitions":
      "在有组织的比赛中进行速降自由式滑雪/单板滑雪",
    "Downhill Mountain Biking": "下坡山地自行车",
    "Ice Climbing": "攀冰",
    "Mixed Martial Arts": "混合武术",
    Mountaineering: "登山运动",
    "Rock Climbing": "攀岩",
    "Football (American and Canadian)": "足球（美式和加拿大式）",
    "Ice Hockey": "冰球",
    Rugby: "英式橄榄球",
    "BASE Jumping": "蹦极",
    "Hang Gliding/Paragliding": "滑翔/滑翔伞",
    "High Risk Snowmobiling": "高风险雪地摩托",
    "Motorized Speed Contests": "摩托车竞赛",
    "Parachuting/Skydiving/Tandem Skydiving": "跳伞/空降/双人跳伞",
    "Scuba Diving or Free Diving Over 40 Metres":
      "水肺潜水或超过40米的自由式潜水",
    "White Water Sports – Class VI": "激流运动",
    "Wingsuit Flying": "机翼飞行",

    // ------------------------Destination
    "destin.notAvailable": "本保障不适用于以下情况:",
    "destin.notAvailContent1": "如果您被诊断出有不治之症;",
    "destin.notAvailContent2": "如果您患有艾滋病或人类免疫缺陷病毒;",
    "destin.notAvailContent3": "如果您在过去12个月内，有使用过家庭氧气治疗的;",
    "destin.notAvailContent4": "如果您被诊断出或接受过充血性心力衰竭治疗的;",
    "destin.notAvailContent5": "如果您接受过重大器官移植的（心、肝、肾、肺）;",
    "destin.notAvailContent6": "如果您在过去12个月接受过肾透析治疗的;",

    "destin.eligible": "为确定适用性，您确认:",
    "destin.eligibleContent1": "年龄超过15天;",
    "destin.eligibleContent2":
      "在保单生效日，不享受也不适用加拿大政府健康保险计划;",
    "destin.eligibleContent3":
      "在购买本计划时健康状况良好，并且在保单生效日，没有任何理由在保障期内寻求医疗服务。",

    "destin.waiting": "等待期:",
    "destin.0to85": "85岁以下",
    "destin.0to85Content1":
      "如果该保险计划是在您抵达加拿大之前购买的，则等待期不适用。",
    "destin.0to85Content2":
      "如果该保险计划是在您抵达加拿大之后购买的，则从保险生效日开始的48小时内所发生的急病产生的医疗费用不在保险范围内。",
    "destin.85andOver": "85岁及以上",
    "destin.85andOverContent1":
      "如果本计划是在抵达加拿大之前购买的，则没有等待期。",
    "destin.85andOverContent2":
      "如果本计划是在抵达加拿大以后购买的，从保单生效日起有15天的等待期。等待期内发生的疾病所产生的相关医疗费用是不在保障范围内的。",
    "destin.waived": "在以下情况下等待期将被免除",
    "destin.waivedContent1":
      "如果本计划是在已有的Destination: Canada policy到期日或之前购买的",
    "destin.waivedContent2":
      "如果在您抵达加拿大以后从另一家保险公司购买过保险，并且您将要购买的本计划和之前的保障没有时间间隔。您需要提供仍然具有效力的另一张保单的有效证明。",

    // ==========================================plan review
    "review.title": "请审阅您的保单信息",
    // ----policy
    "review.deductible": "自负额:",
    "review.coverage": "保障范围:",
    "review.dates": "保单起始日期:",
    "review.datesTo": "到",

    // ----travel plan
    "review.subtitle": "旅行计划",
    "review.to": "访问的省份",

    // ==========================purchase

    "purchase.title": "您的联系方式",
    "purchase.email": "邮件地址",
    "purchase.email2": "确认邮件",
    "purchase.phone": "电话",
    "purchase.wechat": "微信",
    "purchase.address": "完整联系地址",
    "purchase.city": "城市",
    "purchase.prov": "省份",
    "purchase.postal": "邮编",
    "purchase.studentNumber": "学生编号",
    "purchase.canadianAddress": "请提供加拿大境内的地址，比如停留的酒店或家人朋友的地址",
    "purchase.canadianPhone": "请提供有效的加拿大联系电话，例如酒店或家人朋友的电话",
    "purchase.method": "目前只接受visa或master card",

    // ==========================payment

    "payment.title": "购买您的保险计划",
    "payment.name": "持卡人姓名",
    "payment.card_num": "卡号",
    "payment.expiryMon": "月份",
    "payment.expiryYr": "年",
    "payment.cvc": "CVC",

    //=============================purchase sucessful
    "sucess.title": "谢谢!",
    "sucess.string":
      "您的保单已经成功生成。请注意查收分别来自iWare Travel以及直接来自您所选择的保险公司关于保单的确认邮件。",

    // ==============================purchase fail
    "fail.title": "稍等一下，好像出了点问题",
    "fail.string": "交易无法完成。请联系我们的客服。",
    "fail.reason": "可能出错的信息：",

    // ==============================missing info (redirect page)
    "redirect.title": "稍等... 有些信息还需要填写",
    "redirect.text1": "您需要选择",
    "redirect.text2": "您需要填写",
    "redirect.action1": "返回去选择",
    "redirect.action2": "返回去重新填写",
    "redirect.missingItem1": "保障计划",
    "redirect.missingItem2": "旅行者",
    "redirect.missingItem3": "行程",
    "redirect.missingItem4": "购买信息",

    // ==============================404
    "404.text": "啊 页面不存在",

    // ==============================about us
    "about.section1": "我们的故事",
    "about.section1text":
      "我们的创始人之一Lancy Qiu是一名加拿大的移民。她的父母每年都会来加拿大探亲并呆上几个月。有一年，父亲在加拿大突发急病住院三天花费了$13,000加币。不幸中之大幸，她为他们购买了旅游保险，那可以说是她这辈子做的最好的投资之一。",
    "about.section2": "我们努力的方向",
    "about.section2text1": `我们希望可以帮助来加拿大的游客找到最适合他们的最优的旅游保险计划。`,
    "about.section2text2": `我们相信选择旅游保险不应该比计划行程还要复杂。`,
    "about.section3": "我们如何做",
    "about.section3text1": `我们通过与合作的保险公司的系统进行对接从而实现在几分钟内轻松完成在线报价到完成购买收到保单的全过程。`,
    "about.section3text2": `需要帮助? 没问题。我们随时为您答疑解惑。`,

    // ==============================联系我们

    "contact.title": "很高兴为您服务",
    "contact.subtitle": "欢迎给我们留言，我们会尽快回复",
    "contact.name": "姓名",
    "contact.email": "邮箱地址",
    "contact.message": "告诉我们您需要什么帮助...",
    "contact.sent": "您的信息已经发送 :)",
    "contact.emailus": "电邮我们：info@iwaretravel.ca",

    // ==============================in the news

    "in-the-news.title": "媒体报道",
    "in-the-news.1":
      "Latest Cohort of Junction Startups Aim to Grow Calgary's Innovation-Driven Sectors",
    "in-the-news.1date": "Oct. 03, 2019",
    "in-the-news.2": "CHAMPIONS FROM EAST TO WEST.",
    "in-the-news.2date": "Fall 2019",
    "in-the-news.3":
      "iWareTravel: Travel insurance delivered to where you start the trip.",
    "in-the-news.3date": "Fall 2019",
    "in-the-news.4": "Calgary Business Podcast - Episode 28",
    "in-the-news.4date": "Nov. 26, 2019",
    "in-the-news.5": "THE 15 STARTUPS OF ASCENSION 2020",
    "in-the-news.5date": "Feb. 18, 2020",
    "in-the-news.6": "Junction | Founders x Foundations",
    "in-the-news.6date": "2019年12月16日",

    // ==============================view my policy
    "renew.title": "Renew My Policy",
    "view.title": "查看我的保单",
    "view.text": "请输入您的保单号以调取您的保单",
    "view.policyNum": "保单号",
    "view.noResultPolicyNum": "不好意思 根据您的保单号没有找到相应结果",

    //=================================================================errors msg
    "error.nonEmpty": "此栏为必填",
    "error.15days": "不满15天的婴儿不适用此计划",
    "error.18year": "保单持有人必须满18岁",
    "error.fname": "请输入您的名",
    "error.lname": "请输入您的姓",
    "error.bday": "请按照年-月-日的格式输入日期",
    "error.bdayUnborn": "出生日期不能晚于当前日期",
    "error.entername": "请输入名字",
    "error.enterPolicyNum": "请输入保单号",
    "error.validEmail": "请输入正确的邮箱",
    "error.emailMatch": "请输入相同的邮箱",
    "error.general": "不好意思 出了个问题",
    "error.province": "请输入正确的加拿大省份缩写",

    // ============================CUSTOMIZED ERROR QUOTING MESSAGE

    "gms.travelersNum": "GMS规定同一张保单上的申请人数不能超过6人",
    "gms.NoCoverageOrDeductible": "GMS不提供该保障额度/免赔额的选项",
    "tugo.NoCoverageOrDeductible": "Tugo不提供该保障额度/免赔额的选项",
    "tugo学生.NoCoverageOrDeductible": "Tugo不提供该保障额度/免赔额的选项",
    "destination.NoCoverageOrDeductible":
      "Destination不提供该保障额度/免赔额的选项",
    "gms.withoutPreExistingCondition": "GMS不提供不含既往病史保障的保险计划",
    "tugo.withoutPreExistingCondition": "Tugo不提供不含既往病史保障的保险计划",
    "tugoStudent.withoutPreExistingCondition": "Tugo不提供不含既往病史保障的保险计划",
    "tugoStudent.travelCancellationCoverage": "tugo学生保险不提供行程中断/行程取消的保障",
    "tugoStudent.sportsCoverage": "tugo学生保险不提供额外的运动保障",
    "gms.nonFamilyMember": "GMS规定非家庭成员（配偶和/或子女）不能在一张保单上",
    "destination.olderThan80":
      "Destination针对80岁及以上的申请人不提供包含既往病史保障的保险计划",
    "gms.olderThan80": "GMS针对80岁及以上的申请人不提供保险计划",
    "dependantAge": "子女不能超过21岁",
    "gms.dependantAge": "GMS对于子女的定义是不超过19岁",
    "gms.sportsCoverage": "GMS不提供额外的运动保险",
    "gms.travelCancellationCoverage": "GMS公司不提供行程取消/行程中断保障",
    "gms.notForQC": "GMS不提供魁北克省的旅游保险",
    "destination.sportsCoverage": "Destination不提供额外的运动保险",
    "destination.travelCancellationCoverage": "Destination公司不提供行程取消/行程中断保障",
    
    // ============================CLAIM PROCESS PAGE
    "claim.step1": "第一步",
    "claim.step2": "第二步",
    "claim.step3": "第三步",
    "claim.step4": "第四步",
    "claim.step5": "第五步",
    "claim.step6": "第六步",
    "claim.step7": "第七步",
    "insurer.destin": "Destination",
    "insurer.gms": "GMS",
    "insurer.tugo": "Tugo",
    "claim.title": "理赔流程",

    "gms.step1.content": "您本人或者您指定的代理人，必须在接受治疗之前联系GMS",
    "gms.step1.contact": "1.800.459.6604",
    "gms.step1.notes":
      "如果您没有在接受治疗或入院的24小时内通知GMS，您有可能只能获得70%的理赔金额",

    "gms.step2.content": "您需要在急病或意外发生的90天内提交填写完整的理赔申请",
    "gms.step2.contact":
      "https://www.gms.ca/Portals/0/adam/Content/dD_H3sD1zUqQo4iHpH9D7Q/Link/GMS-VTC-Emergency-Medical-Claim-Form-CA.pdf?v=2019-06-12-17-46-17",
    "gms.step2.notes":
      "• 原始详细单据<br>• 支付凭证<br>• 医疗记录包括医生诊断书<br>• 牙齿相关的理赔需要提供事故证明<br>• 旅行日期包括您从始发国的出发日期以及签证<br>• 历史医疗记录",

    "gms.step3.content":
      "并且附上理赔申请中”提示“部分要求的全部材料以及原始详细单据，寄至以下地址：",
    "gms.step3.contact": `Global Allianz Assistance<br>Claims Department<br>P.O. Box 277<br>Waterloo, ON<br>N2J 4A4`,
    "gms.step3.notes":
      "除非是GMS要求的，否则请不要直接向医疗机构支付任何费用。<br>GMS不会返还任何单据，所以请事先保留复印件以备记录",

    "tugo.step1.cap": "理赔登记",
    "tugo.step1.content": "一旦需要住院治疗，您需要在第一时间联系TUGO理赔部门",
    "tugo.step1.contact": `1-800-663-0399`,

    "tugo.step2.cap": "填写并提交理赔申请",
    "tugo.step2.content": "您必须完整填写并提交所有理赔表格",
    "tugo.step2.contact": `https://my.tugo.com/login/auth`,

    "tugo.step3.cap": "提供所需其他资料",
    "tugo.step3.content":
      "您需要提交TUGO理赔部门要求的所有其他信息，比如，相关费用的原始详细单据",
    "tugo.step3.contact": `10th Floor, 6081 No. 3 Road Richmond, BC V6Y 2B2, Canada`,
    "tugo.step3.notes": `• 详细单据<br>• 详细处方药单据<br>• 支付凭证`,

    "tugoStudent.step1.cap": "理赔登记",
    "tugoStudent.step1.content": "一旦需要住院治疗，您需要在第一时间联系TUGO理赔部门",
    "tugoStudent.step1.contact": `1-800-663-0399`,

    "tugoStudent.step2.cap": "填写并提交理赔申请",
    "tugoStudent.step2.content": "您必须完整填写并提交所有理赔表格",
    "tugoStudent.step2.contact": `https://my.tugo.com/login/auth`,

    "tugoStudent.step3.cap": "提供所需其他资料",
    "tugoStudent.step3.content":
      "您需要提交TUGO理赔部门要求的所有其他信息，比如，相关费用的原始详细单据",
    "tugoStudent.step3.contact": `10th Floor, 6081 No. 3 Road Richmond, BC V6Y 2B2, Canada`,
    "tugoStudent.step3.notes": `• 详细单据<br>• 详细处方药单据<br>• 支付凭证`,

    "destination.step1.content": "请立即联系客服中心",
    "destination.step1.contact": "1-855-297-4371",
    "destination.step1.notes":
      "请准备好您的保单信息。所有的信息都可以在您购买保险时收到的“钱包卡”上找到",

    "destination.step2.content":
      "客服中心将帮助您获取所需要的医疗服务，包括下载并使用我们的医疗前台服务的应用程序（StandbyMD），根据您的紧急状况的性质和严重性指导您去相关医院或诊所",
    "destination.step2.notes":
      "https://www.google.com/maps/d/u/0/viewer?mid=14VRMXd9L6BM8Wrx63hx3tEPymf5LcoI3&ll=2.5444437451708134e-14%2C0&z=2",

    "destination.step7.content":
      "如果符合理赔条件，客服中心会直接支付给医疗机构",
    "destination.step7.contact":
      "Active Care Management, P.O. Box 1237, Station A, Windsor, ON N9A 6P8",
    "destination.step7.notes":
      "在特殊情况下，医疗机构与保险公司没有直赔协议的情况下，您可以直接在网上提交理赔申请。 https://manulife.acmtravel.ca/accounts/login/",

    "destination.step6.content":
      "客服中心在核实上述信息后，会审核您的理赔申请并决定是否理赔",

    "destination.step5.content":
      "在审核过程中，客服中心会核实您的保险的有效性、历史医疗记录以及与理赔相关的其他情况",
    "destination.step5.contact": "线上提交理赔申请",
    "destination.step5.notes": "https://manulife.acmtravel.ca/accounts/login/",

    "destination.step4.content":
      "一般来说，您出院以后，客服中心就会开始理赔审核流程。",
    "destination.step4.notes":
      "• 原始详细单据。请您保留复印件以备记录<br>• 所有其他医疗记录、凭据，例如医生诊断，紧急抢救报告，主治医师出具的诊断记录或信<br>• 对于住院的理赔，请提供收治医疗机构出具的医疗记录",

    "destination.step3.content":
      "客服中心将与相关医院或诊所直接联系并跟进您的案子，确保您状况稳定。",

    // =============================== PARTNERS
    "partners.title": "我们的合作伙伴",
    "partners.lloydSadd": "加怡保險",
    "partners.calgaryTour": "Calgary Tour",
    "partners.calgaryTour.text": "to be added",
    "partners.lloydSadd.text":
      "加怡保險-其母公司“Lloyd Sadd Insurance Brokers”為加拿大最大的保險 & 風險管理機構Navacord的創始成員之一. 我們深信我們的顧客除了追求最低廉的保費, 同時也需要最好的保險建議與服務! 我們在汽車, 房屋, 商業, 以及旅遊保險上, 會竭誠為您提供最合適您保障!",

    // ============================= BLOG
    "blog.title": "博客文章",
  },
  en: {
    // ============================NAVIGATION
    "nav.link1": "About Us",
    "nav.link2": "Contact Us",
    "nav.link3": "In The News",
    "nav.link4": "Our Partners",
    "nav.link5": "Blog",
    "nav.btn": "Get Started",
    "nav.quoting.details": "Details",
    "nav.quoting.travellers": "Travellers",
    "nav.quoting.policies": "Policies",
    "nav.quoting.purchase": "Purchase",

    // =========================Homepage
    "home.hero1": "Travelling To Canada?",
    "home.hero2": "Buy Travel Insurance From Canada",
    "home.subcap":
      "Learn about significant benefits when you buy travel insurance from Canada.",
    "home.btn1": "Get Started",
    "home.btn2": "View My policy",

    "home.whyCap": "Why Buy Travel Insurance From Canada?",
    "home.why1.cap": "Direct Billing",
    "home.why1.text": "No need to pay out of your own pocket",
    "home.why2.cap": "Pre-Existing Conditions",
    "home.why2.text":
      "Ever wondered whether your pre-existing conditions are covered?",
    "home.why3.cap": "Already In Canada?",
    "home.why3.text":
      "Not eligible to buy from your home country anymore? Worry not",

    "home.fewCap": "You Are Just A Few Clicks Away From Peace Of Mind",
    "home.few1": "Tell us your trip details. We don't need much.",
    "home.few2":
      "Compare different plans and prices. Choose the one that suits you.",
    "home.few3": "Pay online and get your policy right away",
    "home.fewbtn": "GET MY QUOTE",

    "home.purposeSub": "Travel purposes affect the choice of insurance.",
    "home.purposeCap": "What Is Your Purpose Of Travelling To Canada?",
    "home.purpose1": "Outdoor Adventure",
    "home.purpose1.text":
      "You probably need additional coverage for extreme (contact) sports which might be an exclusion in some plans.",
    "home.purpose2": "Visiting Family",
    "home.purpose2.text":
      "For parents and grandparents, pre-existing condition coverage is strongly recommended. Check out the definitions of pre-existing conditions when you choose the plans.",
    "home.purpose3": "Students or Accompanying Family Members",
    "home.purpose3.text":
      "Full time students may be eligible for international student insurance, which may offer better coverage and premiums.",
    "home.purpose4": "Exploring Opportunities",
    "home.purpose4.text":
      "If you are not sure how long you will stay, buy for the longer period to avoid decline of coverage or increase of premiums for extensions.",

    "home.partner": "We Partner With Brands You Trust",

    "home.vidsup": "Why buy travel insurance from canada?",
    "home.vidcap": "Watch The Short Video To Learn More",

    "home.reviewcap": "Listen To What Our Customers Say",
    "home.review1n": "Elizabeth",
    "home.review1t":
      "The comprehensive travel insurance products and professional considerate services of iWare Travel allows me to enjoy my trip in Canada worry free. Thank you Lancy, and I look forward to doing business with you next time!",
    "home.review2n": "Cathy Liu",
    "home.review2t":
      "I bought travel insurance through iWare Travel for my mom and my sister’s family when they came to visit me in Calgary. Great service, very reliable and accountable. You wont be disappointed.",
    "home.review3n": "Shengzhu Zhang",
    "home.review3t":
      "I am a visiting teacher in the university, I bought 3 policies from iWare Travel for myself and my families. They are always patient in answering all my questions and recommending the best fit travel insurance plan for us.",

    "home.reachoutcap": "Want To Reach Out To Us?",
    "home.reachout": "We would love to hear from you.",
    "home.reachoutbtn": "CONTACT US",

    // =========================footer
    "foot.license": "iWare Travel Insurance is licensed by",
    "foot.resources": "Resources",
    "foot.resources1": "Contact",
    "foot.resources2": "Get My Quote",
    "foot.legal": "Legal",
    "foot.terms": "Terms",
    "foot.licenses": "Licenses",
    "foot.copyright": "© 2020 iWareTravel.ca. All rights reserved.",
    "foot.btn": "Get Started",

    // ========================main buttons
    "btn.continue": "Continue",
    "btn.goback": "Go Back",
    "btn.compareplans": "Compare Benefits",
    "btn.buy": "Buy",
    "btn.wording": "Policy Wording",
    "btn.eligible": "I'm Eligible",
    "btn.notEligible": "I'm Not Eligible",
    "btn.yes": "Yes",
    "btn.no": "No",
    "btn.confirm": "I Confirm",
    "btn.understand": "I Understand & I'm Eligible",
    "btn.change": "change",
    "btn.edit": "edit",
    "btn.purchase": "Purchase",
    "btn.return": "Return",
    "btn.send": "Send",
    "btn.submit": "Submit",
    "btn.renew": "Renew",
    Yes: "Yes",
    No: "No",
    "btn.understand+eligible": "i understand & i'm eligible",
    "btn.yestoall": "yes to all",
    "btn.close": "close",
    "btn.updateQuote": "Update Quote",
    
    // =========================stepper
    "stp.details": "details",
    "stp.travellers": "travellers",
    "stp.policies": "policies",
    "stp.purchase": "purchase",

    // =========================get-my-quote-detials
    "details.title": "Tell Us A Bit About Your Travel Plan",
    "details.from": "travelling from",
    "details.to": "travelling to",
    "details.start": "Policy Start Date",
    "details.end": "Policy End Date",
    "details.arrival": "arrival date",
    "details.applied": "application date (today's date)",
    "details.choose": "Please select",
    "details.purpose": "Purpose of Travels to Canada?",
    "details.purposeHelp": "We collect this information in order to determine the best coverage for you",
    "details.studentTravel": "The policy expires no later than 60 days after you are no  longer enrolled in a school within Canada, please choose the policy expiry date accordingly.",
    "details.studentTravelLinkText": "For details, please refer to the policy wording.",
    "details.studentLabel": "student",
    "details.studentCoverge": "$2,000,000 coverage is applicable to this plan",

    // =========================get-my-quote-travellers
    "travellers.title": "Who Are Travelling?",
    policyholder: "policy holder",
    "travellers.holderfname": "first name",
    "travellers.holderlname": "last name",
    "travellers.holderdob": "date of birth",
    "travellers.holdergender": "gender",
    female: "female",
    male: "male",
    extra: "Do you need extra sports coverage?",
    extraSub: "(Tugo plans only)",
    extraTripInterruption: "Do you need trip interruption coverage?",
    extraTripInterruptionCancellation: "Do you need trip cancellation/trip interruption coverage?",
    
    "traveller.add": "add another traveller",
    "generic.traveller": "traveller",
    "relationship.placeholder": "Relationship to policy holder",

    spouse: "spouse",
    dependant: "dependant",
    other: "other",

    // ===============================get-my-quote-policies

    "policies.title": "Here Are Your Plans",
    "policies.coverage": "Coverage:",
    "policies.deductible": "Deductible:",
    "policies.preexisting": "Pre-Existing Conditions Coverage:",

    // ------------------------------plan-card
    "plan.compare": "COMPARE",
    "plan.items": "Coverage Items",
    "plan.medical": "Medical emergency",
    "plan.comparebenefits": "compare benefits",
    "plan.notice1":
      "Only Tugo plans are available for travelers who are 80 years or older.",
    "plan.notice2":
      "Only Tugo plans are available for travelers who need extra coverage.",
    "plan.includePre": "plans include pre-existing conditions coverage.",
    "plan.unavail": "is not available for the information you entered. ",
    "coverage.items": "coverage items",
    "coverage.policyPeriod": "Policy Period",
    "medical emergency": "Medical emergency",
    "pre-existing conditions": "Pre-existing Conditions",

    "plan.medicalGMS":
      "A sudden or urgent happening that arose during your trip and requires immediate action.",
    "plan.medicalTugo":
      "An unforeseen sickness or injury, which requires immediate medical treatment to alleviate existing danger to life or health.",
    "plan.medicalDestin":
      "A sudden, unforeseen sickness or injury occurring during the period of coverage, which requires immediate intervention by a physician or legally licensed dentist and cannot reasonably be delayed.",

    "plan.pre": "Pre-existing Conditions",
    "gms.pre-existing conditions": `a. medical condition(s) for which you received medical treatment or medical consultation; and/or <br>
		b. undiagnosed medical condition(s) related to symptoms which you received medical treatment or medical consultation.`,
    
    "tugo.pre-existing conditions": `a) A dental or medical condition, illness or injury that has been diagnosed, and for which you have consulted, or received dental or medical treatment before the date you leave for your trip; or, <br>
		b) A dental or medical condition, illness or injury that has not yet been diagnosed, and for which you were experiencing symptoms before the date you leave for your trip; or, <br>
    c) A medically recognized complication or recurrence of a medical or dental condition, illness or injury, whether or not the condition was diagnosed before the date you leave for your trip.`,
    "destination.pre-existing conditions": `A sickness, injury or medical condition, whether or not diagnosed by a physician: <br>
    i) for which you exhibited signs or symptoms; or <br>
    ii) for which you required or received any medical consultation; and <br>
    iii) which existed prior to the effective date of your coverage.`,
    
    "tugoStudent.pre-existing conditions": `a) A dental or medical condition, illness or injury that has been diagnosed, and for which you have consulted, or received dental or medical treatment before the date you leave for your trip; or, <br>
		b) A dental or medical condition, illness or injury that has not yet been diagnosed, and for which you were experiencing symptoms before the date you leave for your trip; or, <br>
    c) A medically recognized complication or recurrence of a medical or dental condition, illness or injury, whether or not the condition was diagnosed before the date you leave for your trip.`,
    "destination.pre-existing conditions": `A sickness, injury or medical condition, whether or not diagnosed by a physician: <br>
    i) for which you exhibited signs or symptoms; or <br>
    ii) for which you required or received any medical consultation; and <br>
    iii) which existed prior to the effective date of your coverage.`,

    "tugo.trip-cancellation-interruption-label": "Choose the Sum Insured Before Departure",
    "tugo.trip-cancellation-interruption-description": "Covers the cost of the travellers trip if they have to cancel before departing, or the trip is interrupted. Choose the closest amount paid in advance.",
    "tugo.trip-interruption-label": "Choose the Sum Insured After Departure",
    "tugo.trip-interruption-description": "Covers unexpected travel costs, if the traveller's trip is interrupted.",
    
    "gms.medical emergency":
      "A sudden or urgent happening that arose during your trip and requires immediate action.",
    "tugo.medical emergency":
      "An unforeseen sickness or injury, which requires immediate medical treatment to alleviate existing danger to life or health.",
    "tugoStudent.medical emergency":
      "An unforeseen sickness or injury, which requires immediate medical treatment to alleviate existing danger to life or health.",
    "destination.medical emergency":
      "A sudden, unforeseen sickness or injury occurring during the period of coverage, which requires immediate intervention by a physician or legally licensed dentist and cannot reasonably be delayed.",

    "plan.triplength": "Trip length",
    "plan.triplengthUnit": "days",

    // -------------------------Compare Benefits
    "benefits.title": "Compare Benefits",
    "all coverages": "all coverages",
    "all deductibles": "all deductibles",
    "Covid-19 coverage": "Covid-19 coverage",
    "drugs or medications": "drugs or medications",
    "emergency hospital": "emergency hospital",
    "follow-up visits": "follow-up visits",
    "age limit": "age limit",
    Repatriation: "Repatriation",
    "dental emergency": "dental emergency",
    "Accidental Death & Dismemberment": "Accidental Death & Dismemberment",
    "Waiting period": "Waiting period",
    "Paramedical Services": "Paramedical Services",
    "Pre-existing medical conditions": "Pre-existing medical conditions",
    "Pre-existing conditions coverage age limit":
      "Pre-existing conditions coverage age limit",
    Maternity: "Maternity",
    "Optional non-medical coverage": "Optional non-medical coverage",
    "benefits.disclaimer":
      "Please note this is just a summary of the benefits, please refer to the policy wording for more details",

    "all coverages.destination":
      "$10,000 - $25,000 - $50,000 - $100,000 - $150,000 or $300,000",
    "all deductibles.destination":
      "$0 - $250 - $500 - $1,000 - S2,500 - $5,000 - $10,000",
    "age limit.destination": "None",
    "Covid-19 coverage.destination": "Yes, but side trips not covered",
    "drugs or medications.destination":
      "up to $1,000 not exceeding 30-day supply",
    "emergency hospital.destination": "semi-private",
    "Paramedical Services.destination": "up to $500 per practitioner",
    "follow-up visits.destination": "Up to CAD3,000",
    "Repatriation.destination":
      "Up to $3,000 for a one-way economy transportation",
    "dental emergency.destination":
      "Up to CAD3,000 for accidental blow to the face, up to CAD500 for relief of dental pain",
    "Accidental Death & Dismemberment.destination":
      "Up to the maximum sum of insured not to exceed of CAD150,000. Flight accident up to $50,000.",
    "Waiting period.destination":
      "If purchased after arrival in Canada, 48 hours applicable to sickness (age 0 to 85). 15 days (age 86 and over)",
    "Pre-existing medical conditions.destination":
      "For 0 to 79, who chooses the Option with pre-existing coverage, 120 days stable period",
    "Pre-existing conditions coverage age limit.destination":
      "Up to 79 years old",
    "Maternity.destination": "None",
    "Optional non-medical coverage.destination": "None",

    "all coverages.gms": "$25,000 - $50,000 - $100,000 - $150,000",
    "all deductibles.gms": "$0 - $100 - $500 - $1,000",
    "age limit.gms": "Under 80 years old",
    "Covid-19 coverage.gms": "None",
    "drugs or medications.gms": "Up to a 30 day prescription",
    "emergency hospital.gms": "semi-private",
    "Paramedical Services.gms": "up to $300",
    "follow-up visits.gms":
      "Covered until the medical emergency has been deemed to have ended",
    "Repatriation.gms": "Up to $5,000 to transport you home",
    "dental emergency.gms":
      "Up to $2,000 per person and up to $250 for the relief of dental pain",
    "Accidental Death & Dismemberment.gms": "N/A",
    "Waiting period.gms":
      "If purchased within 30 days of arrival, 2 day waiting period. If purchased more than 30 days of arrival, 7 day waiting period",
    "Pre-existing medical conditions.gms":
      "Covered stable conditions during 180 days prior to the effective date",
    "Pre-existing conditions coverage age limit.gms": "Up to 79 years old",
    "Maternity.gms": "None",
    "Optional non-medical coverage.gms": "None",

    "all coverages.tugo":
      "$10,000 - $25,000 - $50,000 - $100,000 - $200,000 or $300,000",
    "all deductibles.tugo":
      "$0 - $150 - $500 - $1,000 - $2,500 - S5,000 - $10,000",
    "age limit.tugo": "None",
    "Covid-19 coverage.tugo": "Yes, and side trips covered",
    "drugs or medications.tugo": "Up to a 30-day supply",
    "emergency hospital.tugo": "semi-private",
    "Paramedical Services.tugo": "Up to $600 per practitioner",
    "follow-up visits.tugo": "Up to 5 follow up visits within 14 days",
    "Repatriation.tugo":
      "Up to the sum insured for preparation and return of the body",
    "dental emergency.tugo":
      "Up to $6,000 for accidental blow to the face, Up to $600 for any other dental emergencies",
    "Accidental Death & Dismemberment.tugo":
      "Air flight/common carrier up to $100,000. 24-hour accident up to $25,000",
    "Waiting period.tugo":
      "If purchased within 60 days of arrival, 48-hour waiting period on sickness. 7-day if purchased 61 days or more after arrival",
    "Pre-existing medical conditions.tugo":
      "For 59 years and under, 120 days stable period. for 60 to 69 years, 180 days stable period. For 70 above, 365 days stable period",
    "Pre-existing conditions coverage age limit.tugo": "None",
    "Maternity.tugo":
      "Up to $6,000 for pre-natal care, delivery and/or complications thereof",
    "Optional non-medical coverage.tugo": "Sports and activities coverage",


    "all coverages.tugoStudent":
      "$2,000,000",
    "all deductibles.tugoStudent":
      "$0",
    "age limit.tugoStudent": "69 years and under",
    "Covid-19 coverage.tugoStudent": "Yes, and side trips covered",
    "drugs or medications.tugoStudent": "Up to a 30-day supply and $10,000",
    "emergency hospital.tugoStudent": "semi-private",
    "Paramedical Services.tugoStudent": "Up to $600 per practitioner",
    "follow-up visits.tugoStudent": "---",
    "Repatriation.tugoStudent":
      "Up to 25,000 for repatriation, up to 5,000 for burial at place of death",
    "dental emergency.tugoStudent":
      "Up to $5,000 for accidents, Up to $600 for dental pain",
    "Accidental Death & Dismemberment.tugoStudent":
      "$10,000. optional limits available: Air flight/common carrier - $100,000, 24-hour Accident - $25,000",
    "Waiting period.tugoStudent":
      "---",
    "Pre-existing medical conditions.tugoStudent":
      "Covered if stable in the 90 days prior to the effective date",
    "Pre-existing conditions coverage age limit.tugoStudent": "69 years old and under",
    "Maternity.tugoStudent":
      "Up to $25,000 if pregnancy commenced during period of coverage",
    "Optional non-medical coverage.tugoStudent": "---",

    // =========================plan purchase
    "purchase.title2": "Some Important Information To Confirm First",

    // -------------------------gms plan
    "gms.under55":
      "Under the age of 55 years old, you will NOT be eligible if you:",
    "gms.under55content1":
      "1. have any reason to seek medical treatment, excluding the regular care of a chronic condition or medical evaluation required to satisfy travel visa requirements;",
    "gms.under55content2":
      "2. are currently in Canada, and have ever been denied similar coverage offered by another Canadian insurer; and",
    "gms.under55content3":
      "3. are currently in Canada, and had more than $5,000 in medical treatment in the last twelve (12) months while in Canada.",

    "gms.55orOlder":
      "At the age of 55 years old or above, you will NOT be eligible if you:",
    "gms.55orOlderContent1":
      "1. are eighty (80) years of age or older on the policy effective date;",
    "gms.55orOlderContent2":
      "2. have any reason to seek medical treatment, excluding the regular care of a chronic condition or medical evaluation required to satisfy travel visa requirements;",
    "gms.55orOlderContent3":
      "3. are currently in Canada, and have ever been denied similar coverage offered by another Canadian insurer;",
    "gms.55orOlderContent4":
      "4. are currently in Canada, and had more than $5,000 in medical treatment in the last twelve (12) months while in Canada;",
    "gms.55orOlderContent5":
      "5. are expecting medical treatment for heart disease;",
    "gms.55orOlderContent6":
      "6. are waiting for test(s) for a suspected heart condition;",
    "gms.55orOlderContent7":
      "7. are taking prescription drugs for heart disease while taking insulin to treat diabetes;",
    "gms.55orOlderContent8":
      "8. have an implantable cardioverter defibrillator (ICD); daily living (ADL) if you are seventy (70) years of age or older; and/or",
    "gms.55orOlderContent9":
      "9. fainted or fell more than once without medical diagnosis (syncope);",
    "gms.55orOlderContent10": "10. use home oxygen for a medical condition;",
    "gms.55orOlderContent11":
      "11. take oral steroids to treat a lung condition;",
    "gms.55orOlderContent12":
      "12. are being treated for cancer or have Metastic Cancer;",
    "gms.55orOlderContent13":
      "13. have a vascular aneurysm that is surgically untreated;",
    "gms.55orOlderContent14":
      "14. have ever had: <br>a. a valve replacement; <br>b. kidney (renal) dialysis; or <br>c. an organ transplant;",
    "gms.55orOlderContent15":
      "15. were diagnosed; received new medical treatment (e.g. consultation, tests or prescription drugs); or had a change in your medical treatment (e.g. a stop, start or dosage change to a prescription drug, other than a dosage change of Coumadin or Warfarin) for, any of the following conditions in the last twelve (12) months: <br>a. congestive heart failure; <br>b. atrial flutter; <br>c. atrial / ventricular fibrillation; <br>d. peripheral vascular disease; <br>e. terminal illness; <br>f. blood clots; or <br>g. gastrointestinal bleeding;",
    "gms.55orOlderContent16":
      "16. require assistance from another person(s) with activities of daily living (ADL) if you are seventy (70) years of age or older.",

    "gms.loc": "Are You Currently In Canada?",
    "gms.inCA1":
      "I am purchasing this plan to replace my current Canadian health insurance plan.",
    "gms.inCA2":
      "I have been in Canada for LESS than 30 days and am not currently covered by a Canadian health insurance plan.",
    "gms.inCA3":
      "I have been in Canada for MORE than 30 days and am not currently covered by a Canadian health insurance plan.",

    "gms.declaration": `I/We ("I") declare the statements made herein are true and complete and shall form part of my application for coverage. I hereby authorize any physician, health care provider, other person, hospital, institution, or insurance company to release to Group Medical Services and/or its authorized agents, representatives, affiliates or other service providers (collectively "GMS") any information covering my medical history, symptoms, treatment, examination, diagnosis and/or services rendered to myself or any of my dependants herein listed. 
    <br>For the purposes of administering any Group Medical Services ("GMS") benefits, products or services (collectively "benefits") and/or determining eligibility for benefits, I authorize GMS to: (a) collect, store and use any personal information which I have provided to GMS or personal information obtained pursuant to clause (b); and/or (b) obtain personal information about me (or any other person listed herein) from, or disclose such personal information to: my Government Health Insurance Plan; the operator of any hospital, clinic, or other health facility; a doctor or other health care provider; any insurance company; or any other service provider or third party as may be reasonably required for the purposes described above. <br>I warrant that neither I, nor any person herein listed, have any additional coverage through any insurer other than the information listed herein. Should I, or any person herein listed, subsequently obtain additional coverage through any insurer, while covered under this contract, I will immediately advise GMS in writing. I hereby authorize GMS to coordinate any eligible expenses with any additional insurer that I, or any person herein listed, may have coverage under. 
    <br>I understand that, whether before or after my application, any misrepresentation, incorrect or concealed information or failure to fully complete all sections of the application may void my coverage. I declare that, if I am signing on behalf of any person(s), I have the authority to sign on behalf of such person(s) listed herein and confirm that each of the above declarations and authorizations are also provided on behalf of such person(s).`,

    "btn.gms.eligibleI": "i'm eligible",
    "btn.gms.eligibleWe": "we're eligible",
    "gms.declare.title": "DECLARATION",

    "gms.inCA.replace.cap": "current canadian health insurance plan",
    "gms.inCA.replace.company": "insurance company",
    "gms.inCA.replace.policyNum": "policy number",
    "gms.inCA.replace.expiryDate": "Policy Expiry Date",
    "gms.inCA.lessThan30":
      "You will have to wait 2 days from your effective date before you can make a claim for an illness under your plan.",
    "gms.inCA.moreThan30":
      "You will have to wait 7 days from your effective date before you can make a claim for an illness under your plan.",

    // -------------------------Tugo

    // "tugo.eligibility": "Eligibility",
    // "tugo.cap": "Are you eligible for coverage?",
    // "tugo.content": [
    //   "At the time of application, you are eligible for coverage if:",
    //   "1. You are not travelling against a physician's advice.",
    //   "2. You have not been diagnosed with a terminal condition..",
    //   "3. You are not receiving palliative care or palliative care has not been recommended.",
    // ],
    // "tugo.declaration": `The traveller confirms that they know of no reason for which they may seek medical attention.
    // <br>The traveller confirms that they have not seen a physician or other registered medical practitioner since their arrival in Canada
    // <br>The traveller confirms that they have not submitted a in-the-news and no circumstance is known for which a in-the-news may be made.
    // <br>The traveller confirms that if this policy is purchased within 60 days after their arrival in Canada, there is no coverage for any sickness arising in, occurring sin or symptomatic during the first 48 hours from the effective date of this policy.
    // <br>The traveller understands that if this policy is purchase more than 60 days after their arrival in Canada, there is no coverage for any sickness arising in, occurring in or symptomatic during the first 7 days from the effective date of this policy.`,
    // -------------------------Tugo

    "tugo.mq.heading": "Medical Questionnaire",
    "tugo.mq.sub":
      "Based on your age, we need to ask some medical questions 🙂",
    "tugo.mq.q1": "1. Have you had any of the following in the last 12 months?",
    "tugo.mq.q1.a1": "Myocardial infarction also known as heart attack",
    "tugo.mq.q1.a2":
      "Stroke and/or Transient Ischemic Attack (TIA) also known as mini-stroke",
    "tugo.mq.q1.a3":
      "Arterial by-pass, angioplasty and/or placement of a stent for a cardiovascular condition",
    "tugo.mq.q1.a4": "None",
    "tugo.mq.q2":
      "2. Have you had any of these conditions in the last 12 months?",
    "tugo.mq.q2.description":
      "Choose a condition if, in the specified timeframe, you had the condition, whether or not you received any medical care for it. <br>This includes conditions controlled or managed by medication, a medical device, diet or excercise.",
    "tugo.mq.q2.a1": "Atrial fibrillation",
    "tugo.mq.q2.a2": "Diabetes requiring insulin",
    "tugo.mq.q2.a3": "Liver disease, excluding liver cancer",
    "tugo.mq.q2.a4": "Pneumonia",
    "tugo.mq.q2.a5": "Coronary artery disease (CAD)",
    "tugo.mq.q2.a6":
      "Arteriosclerosis and/or atherosclerosis also known as hardening of the arteries",
    "tugo.mq.q2.a7":
      "Chronic Obstructive Pulmonary Disease (COPD), including emphysema, not requiring home oxygen",
    "tugo.mq.q2.a8": "Asthma",
    "tugo.mq.q2.a9": "None",
    "tugo.mq.q3":
      "3. In the last 12 months, have you smoked any tobacco products, or vaped any nicotine products (including e-cigarettes)?",
    "tugo.mq.q3.a1": "Yes",
    "tugo.mq.q3.a2": "No",

    "tugo.mq.disclaimer.header": "MQ Disclaimer",
    "tugo.mq.disclaimer.content": `It is important to answer the Medical Questionnaire correctly. If you qualify for the insurance but you or a representative buying insurance on your behalf inaccurately answer any of the Rate Qualification questions, a $15,000 CAD deductible applies to any incident claimed, in addition to any other deductible you may have selected. 
    At the time of a claim, if the answers are not complete or accurate, coverage won’t be provided until you correct your answers and, if applicable, you pay any additional premium that may be required.`,

    "tugo.firstEligibility.cap": "Please review and confirm the statements below",
    "tugo.firstEligibility1": `If you have already left your home country, please review and confirm the statements below. Coverage is only available if you can accurately respond with "Yes to All". If your confirmation is not accurate, coverage may be void.<br><br>If you are still in your home country, answer "Yes to all" to bypass these statements.`,
    "tugo.firstEligibility2": `1. I am not currently experiencing any symptoms.`,
    "tugo.firstEligibility3": `2. I do not currently need medical attention. `,
    "tugo.firstEligibility4": `3. I have not seen a physician and/or any other registered medical practitioner since my arrival in Canada (or on or within the last 182 days if your arrival date is more than 182 days from the application date).`,
    "tugo.firstEligibility5": `A waiting period may apply for any claims related to sickness if the policy was purchased after arrival in Canada. For complete details, refer to the policy wording.`,

    "tugo.eligibility.header": "Eligibility Statement",
    "tugo.eligibility.cap":
      "At the time of application, you are eligible for coverage if",
    "tugo.eligibility.content1":
      "1. You know of no reason for which you may seek medical attention.",
    "tugo.eligibility.content2": `2. You are:
  a) A foreign worker, international student studying in Canada or a visitor to Canada with valid legal status in Canada; or,
  b) An immigrant awaiting provincial or territorial government health care coverage; or,
  c) A Canadian returning to Canada from an extended leave who is eligible for but not yet covered by a provincial or territorial government health care plan.`,
    "tugo.eligibility.content3":
      "3. You are not travelling against a physician or other registered medical practitioner’s advice.",
    "tugo.eligibility.content4":
      "4. You have not been diagnosed with a terminal condition.",
    "tugo.eligibility.content5":
      "5. You are not receiving palliative care or palliative care has not been recommended.",
    "tugo.eligibility.content6":
      "6. You do not have Chronic Obstructive Pulmonary Disease (COPD), including emphysema, requiring home oxygen.",
    "tugo.eligibility.content7":
      "7. You do not have pancreatic cancer, liver cancer or any type of cancer that has metastasized or that required a bone marrow transplant.",
    "tugo.eligibility.content8":
      "8. You do not have kidney disease requiring dialysis.",
    "tugo.eligibility.content9":
      "9. You have not had or are not waiting for an organ transplant.",
    "tugo.eligibility.content10":
      "10. You have not been diagnosed with congestive heart failure also known as pulmonary edema.",

    "tugo.terms.cap": "Terms and conditions",

    "tugo.finalConfirmation": `<b>Important information<b> <br>This document does not constitute the entire insurance policy and you have been advised to read the policy booklet for full details on coverage and exclusions. <br><u>Applicable to all plans<u> <br>• You understand that the medical conditions disclosed on this application may not be covered and that details of when preexisting conditions are covered are set out in the policy booklet. <br>• A pre-existing condition exclusion may apply to you. Read the policy booklet for details on the pre-existing condition exclusion that may apply to you. <br>• You hereby authorize any hospital, physician or other person or organization that has records or knowledge of your health or medical history to provide that information to the company (as defined in the policy booklet) and Claims at TuGo and you authorize the company and Claims at TuGo to use and disclose that information to determine whether any claim that may be made is covered by this policy or by another plan or policy. <br>• In the event of a claim that may require or result in hospitalization, call Claims at TuGo immediately. <br><tab>From Canada & USA: 1-800-663-0399<tab> <br><tab>From Mexico: 001-800-514-9976<tab> <br><tab>Collect call worldwide: 604-278-4108<tab> <br>• You or any representative purchasing insurance on your behalf consent to TuGo and Claims at TuGo collecting, using and disclosing your personal information for the purposes of approving your insurance application, confirming coverage and/or benefits, processing your claims as well as informing you of other products and services offered by TuGo and its affiliates. You have read and agreed to TuGo’s Privacy Policy, which is available at https://www.tugo.com/en/privacy/. <br>• You may already have travel insurance through another insurance provider (e.g., a credit card or group plan). However, this may not provide adequate coverage for your trip. <br>• Coverage under this Policy will be void if you do not meet the eligibility requirements for the plan selected. Coverage under this Policy will be void if there is any misrepresentation or concealment of or failure to disclose any facts asked at the time of application. <br><u>Applicable to Emergency Medical Insurance<u> <br>• You confirm that you are not currently experiencing symptoms. <br>• You understand that a waiting period may apply for any claims related to disease or illness if the policy was purchased after arrival in Canada. For complete details, refer to the policy wording. <br><u>Applicable to Trip Cancellation & Trip Interruption and Trip Interruption Only<u> <br>• You confirm that currently no circumstance is known which might reasonably be expected to prevent your travel as scheduled. <br>You have read the terms and conditions which apply to the policy as set out above and understand and agree to those terms and conditions on behalf of yourself and all persons for whom you are applying for insurance.`,

    "tugo.optional.cover.cap": "optional coverage (Tugo only)",

    // -------------------------TugoStudent

    "tugoStudent.mq.heading": "Medical Questionnaire",
    "tugoStudent.mq.sub":
      "Based on your age, we need to ask some medical questions 🙂",
    "tugoStudent.mq.q1": "1. Have you had any of the following in the last 12 months?",
    "tugoStudent.mq.q1.a1": "Myocardial infarction also known as heart attack",
    "tugoStudent.mq.q1.a2":
      "Stroke and/or Transient Ischemic Attack (TIA) also known as mini-stroke",
    "tugoStudent.mq.q1.a3":
      "Arterial by-pass, angioplasty and/or placement of a stent for a cardiovascular condition",
    "tugoStudent.mq.q1.a4": "None",
    "tugoStudent.mq.q2":
      "2. Have you had any of these conditions in the last 12 months?",
    "tugoStudent.mq.q2.description":
      "Choose a condition if, in the specified timeframe, you had the condition, whether or not you received any medical care for it. <br>This includes conditions controlled or managed by medication, a medical device, diet or excercise.",
    "tugoStudent.mq.q2.a1": "Atrial fibrillation",
    "tugoStudent.mq.q2.a2": "Diabetes requiring insulin",
    "tugoStudent.mq.q2.a3": "Liver disease, excluding liver cancer",
    "tugoStudent.mq.q2.a4": "Pneumonia",
    "tugoStudent.mq.q2.a5": "Coronary artery disease (CAD)",
    "tugoStudent.mq.q2.a6":
      "Arteriosclerosis and/or atherosclerosis also known as hardening of the arteries",
    "tugoStudent.mq.q2.a7":
      "Chronic Obstructive Pulmonary Disease (COPD), including emphysema, not requiring home oxygen",
    "tugoStudent.mq.q2.a8": "Asthma",
    "tugoStudent.mq.q2.a9": "None",
    "tugoStudent.mq.q3":
      "3. In the last 12 months, have you smoked any tobacco products, or vaped any nicotine products (including e-cigarettes)?",
    "tugoStudent.mq.q3.a1": "yes",
    "tugoStudent.mq.q3.a2": "no",

    "tugoStudent.mq.disclaimer.header": "MQ Disclaimer",
    "tugoStudent.mq.disclaimer.content": `It is important to answer the Medical Questionnaire correctly. If you qualify for the insurance but you or a representative buying insurance on your behalf inaccurately answer any of the Rate Qualification questions, a $15,000 CAD deductible applies to any incident claimed, in addition to any other deductible you may have selected. 
    At the time of a claim, if the answers are not complete or accurate, coverage won’t be provided until you correct your answers and, if applicable, you pay any additional premium that may be required.`,

    "tugoStudent.firstEligibility.cap": "Please review and confirm the statements below",
    "tugoStudent.firstEligibility1": `If you have already left your home country at the time you are purchasing this insurance and you have sought treatment since your departure and/or you are currently experiencing any symptoms that are new or worsening, there is no coverage with respect to the medical condition or symptom, related condition or symptom, or for any subsequent treatment related to the condition or symptom.`,
    // "tugoStudent.firstEligibility2": `1. I am not currently experiencing any symptoms.`,
    // "tugoStudent.firstEligibility3": `2. I do not currently need medical attention. `,
    // "tugoStudent.firstEligibility4": `3. I have not seen a physician and/or any other registered medical practitioner since my arrival in Canada (or on or within the last 182 days if your arrival date is more than 182 days from the application date).`,
    // "tugoStudent.firstEligibility5": `A waiting period may apply for any claims related to sickness if the policy was purchased after arrival in Canada. For complete details, refer to the policy wording.`,

    "tugoStudent.eligibility.header": "Eligibility Statement",
    "tugoStudent.eligibility.cap":
      "At the time of application, you are eligible for coverage if",
    "tugoStudent.eligibility.content1":
      "1. You must be a student enrolled in a school or an accompanying family member.",
    "tugoStudent.eligibility.content2": `2. You must not be travelling against a physician's advice.`,
    "tugoStudent.eligibility.content3": "3. You must not have been diagnosed with a terminal condition.",
    // "tugoStudent.eligibility.content4": "4. You have not been diagnosed with a terminal condition.",
    // "tugoStudent.eligibility.content5":
    //   "5. You are not receiving palliative care or palliative care has not been recommended.",
    // "tugoStudent.eligibility.content6":
    //   "6. You do not have Chronic Obstructive Pulmonary Disease (COPD), including emphysema, requiring home oxygen.",
    // "tugoStudent.eligibility.content7":
    //   "7. You do not have pancreatic cancer, liver cancer or any type of cancer that has metastasized or that required a bone marrow transplant.",
    // "tugoStudent.eligibility.content8":
    //   "8. You do not have kidney disease requiring dialysis.",
    // "tugoStudent.eligibility.content9":
    //   "9. You have not had or are not waiting for an organ transplant.",
    // "tugoStudent.eligibility.content10":
    //   "10. You have not been diagnosed with congestive heart failure also known as pulmonary edema.",

    "tugoStudent.terms.cap": "Terms and conditions",

    "tugoStudent.finalConfirmation": `<b>Important information<b> <br>This document does not constitute the entire insurance policy and you have been advised to read the policy booklet for full details on coverage and exclusions. <br><u>Applicable to all plans<u> <br>• You understand that the medical conditions disclosed on this application may not be covered and that details of when preexisting conditions are covered are set out in the policy booklet. <br>• A pre-existing condition exclusion may apply to you. Read the policy booklet for details on the pre-existing condition exclusion that may apply to you. <br>• You hereby authorize any hospital, physician or other person or organization that has records or knowledge of your health or medical history to provide that information to the company (as defined in the policy booklet) and Claims at TuGo and you authorize the company and Claims at TuGo to use and disclose that information to determine whether any claim that may be made is covered by this policy or by another plan or policy. <br>• In the event of a claim that may require or result in hospitalization, call Claims at TuGo immediately. <br><tab>From Canada & USA: 1-800-663-0399<tab> <br><tab>From Mexico: 001-800-514-9976<tab> <br><tab>Collect call worldwide: 604-278-4108<tab> <br>• You or any representative purchasing insurance on your behalf consent to TuGo and Claims at TuGo collecting, using and disclosing your personal information for the purposes of approving your insurance application, confirming coverage and/or benefits, processing your claims as well as informing you of other products and services offered by TuGo and its affiliates. You have read and agreed to TuGo’s Privacy Policy, which is available at https://www.tugo.com/en/privacy/. <br>• You may already have travel insurance through another insurance provider (e.g., a credit card or group plan). However, this may not provide adequate coverage for your trip. <br>• Coverage under this Policy will be void if you do not meet the eligibility requirements for the plan selected. Coverage under this Policy will be void if there is any misrepresentation or concealment of or failure to disclose any facts asked at the time of application. <br><u>Applicable to Emergency Medical Insurance<u> <br>• You confirm that you are not currently experiencing symptoms. <br>• You understand that a waiting period may apply for any claims related to disease or illness if the policy was purchased after arrival in Canada. For complete details, refer to the policy wording. <br><u>Applicable to Trip Cancellation & Trip Interruption and Trip Interruption Only<u> <br>• You confirm that currently no circumstance is known which might reasonably be expected to prevent your travel as scheduled. <br>You have read the terms and conditions which apply to the policy as set out above and understand and agree to those terms and conditions on behalf of yourself and all persons for whom you are applying for insurance.`,

    "tugoStudent.optional.cover.cap": "optional coverage (Tugo only)",


    None: "None",
    "Backcountry Skiing/Snowboarding": "Backcountry Skiing/Snowboarding",
    Boxing: "Boxing",
    "Downhill Freestyle Skiing/Snowboarding in Organized Competitions":
      "Downhill Freestyle Skiing/Snowboarding in Organized Competitions",
    "Downhill Mountain Biking": "Downhill Mountain Biking",
    "Ice Climbing": "Ice Climbing",
    "Mixed Martial Arts": "Mixed Martial Arts",
    Mountaineering: "Mountaineering",
    "Rock Climbing": "Rock Climbing",
    "Football (American and Canadian)": "Football (American and Canadian)",
    "Ice Hockey": "Ice Hockey",
    Rugby: "Rugby",
    "BASE Jumping": "BASE Jumping",
    "Hang Gliding/Paragliding": "Hang Gliding/Paragliding",
    "High Risk Snowmobiling": "High Risk Snowmobiling",
    "Motorized Speed Contests": "Motorized Speed Contests",
    "Parachuting/Skydiving/Tandem Skydiving":
      "Parachuting/Skydiving/Tandem Skydiving",
    "Scuba Diving or Free Diving Over 40 Metres":
      "Scuba Diving or Free Diving Over 40 Metres",
    "White Water Sports – Class VI": "White Water Sports – Class VI",
    "Wingsuit Flying": "Wingsuit Flying",

    // ------------------------Destination
    "destin.notAvailable": "Coverage will NOT be available if you:",
    "destin.notAvailContent1": "Have been diagnosed with a terminal illness;",
    "destin.notAvailContent2":
      "Have Acquired Immune Deficiency Syndrome (AIDS) or Human Immunodeficiency Virus (HIV);",
    "destin.notAvailContent3":
      "Have been prescribed or used home oxygen treatment in the last 12 months;",
    "destin.notAvailContent4":
      "Have been diagnosed with or treated for congestive heart failure;",
    "destin.notAvailContent5":
      "Have had a major organ transplant (heart, kidney, liver, lung);",
    "destin.notAvailContent6":
      "Have received kidney dialysis treatment in the last 12 months;",

    "destin.eligible": "To be eligible, you confirm that you are:",
    "destin.eligibleContent1": "At least 15 days old;",
    "destin.eligibleContent2":
      "On the effective date, not be insured or eligible for benefits under a Canadian government health insurance plan;",
    "destin.eligibleContent3":
      "In good health at the time you purchase your policy and on the effective date, and know of no reason why you would attend any medical consultation during the period of coverage.",

    "destin.waiting": "Waiting period:",
    "destin.0to85": "Age 0 to 85",
    "destin.0to85Content1":
      "If the insurance was purchased prior to your arrival date in Canada, the “waiting period” does not apply or,",
    "destin.0to85Content2":
      "If this insurance is purchased any time after your arrival in Canada, then in respect of any sickness you will only be entitled to receive benefits for the cost of eligible medical expenses incurred after the first 48 hours from the effective date of the policy.",
    "destin.85andOver": "Age 85 and over",
    "destin.85andOverContent1":
      "If the insurance was purchased prior to arrival date in Canada, the “waiting period” does not apply.",
    "destin.85andOverContent2":
      "If the insurance is purchased after your arrival date in Canada, then in respect of any sickness you will only be entitled to receive benefits for the cost of eligible medical expenses incurred after fifteen (15) days from the effective date of this policy.",
    "destin.waived": "The waiting period may be waived if:",
    "destin.waivedContent1":
      "This policy is purchased on or prior to the expiry date of an existing Destination: Canada policy.",
    "destin.waivedContent2":
      "If you have insurance with another insurer during the first part of your trip in Canada, and you are purchasing this insurance after your arrival in Canada and there will be no gap in coverage. You must provide satisfactory proof that you have other coverage in force and receive a written approval from the Insurer.",

    // ==========================================plan review
    "review.title": "Now Let's Review Your Policy",
    // ----policy
    "review.deductible": "Deductible:",
    "review.coverage": "Coverage:",
    "review.dates": "Policy Start-to-End Date:",
    "review.datesTo": "to",

    // ----travel plan
    "review.subtitle": "Travel Plan",
    "review.to": "Visiting Province",

    // ==========================purchase

    "purchase.title": "Your Contact Information",
    "purchase.email": "Email",
    "purchase.email2": "Confirm email",
    "purchase.phone": "Phone",
    "purchase.wechat": "WeChat Username",
    "purchase.address": "Full Residence Address",
    "purchase.city": "City",
    "purchase.prov": "Province",
    "purchase.postal": "Postal Code",
    "purchase.studentNumber": "Student Number",
    "purchase.canadianAddress": "Address provided has to be a Canadian address of stay, for example, your family and friends address or hotel",
    "purchase.canadianPhone": "Phone number provided has to be a valid Canadian phone, for example, your family and friends number or hotel",
    "purchase.method": "At this time we only accept Visa or MasterCard",

    // ==========================payment

    "payment.title": "Purchase Your Policy",
    "payment.name": "Cardholder's Name",
    "payment.card_num": "Card Number",
    "payment.expiryMon": "Month",
    "payment.expiryYr": "Year",
    "payment.cvc": "CVC",

    //=============================purchase sucessful
    "sucess.title": "Thank You!",
    "sucess.string":
      "Your policy has been successfully created. Look out for emails sent from us and your insurer of choice about your policy wording and confirmation.",

    // ==============================purchase fail
    "fail.title": "Oops... Something went wrong",
    "fail.string":
      "We are unable to process your payment for the plan shown below. If the problem persists, please contact your broker to complete the transaction.",
    "fail.reason": "The possible reason of this failure might be:",

    // ==============================missing info (redirect page)
    "redirect.title": "Oops... Missing Some Information",
    "redirect.text1": "Looks like you have not selected a ",
    "redirect.text2": "Looks like you have not filled out the ",
    "redirect.action1": "go back to select one.",
    "redirect.action2": "go back to fill that out.",
    "redirect.missingItem1": "plan",
    "redirect.missingItem2": "travellers",
    "redirect.missingItem3": "travel plan",
    "redirect.missingItem4": "payment information",

    // ==============================404
    "404.text": "Looks like The Page You are looking for doesn't exist",

    // ==============================about us
    "about.section1": "Our Story",
    "about.section1text":
      "The CEO and co-founder Lancy Qiu is an immigrant to Canada. Her family visits her every year from their home country. One year, her dad was hospitalized for three days while visiting Canada, resulting in a $13,000 bill. Luckily she had bought travel insurance for him. It was one of the best investments she's ever made.",
    "about.section2": "Our Goal",
    "about.section2text1": `Our goal is to help millions of people who travel to Canada to find the best, affordable travel insurance that meet their and their families' needs.`,
    "about.section2text2": `We believe choosing insurance can be as easy as shopping cakes, with the right care and attention.`,
    "about.section3": "Our Approach",
    "about.section3text1": `We proudly provide to our customers our fully integrated and easy-to-use online quoting system where purchases of plans can be done at the fingertips. `,
    "about.section3text2": `Need in-person help? No problem. We will take care of your concerns with our expertise in the field.`,

    // ==============================contact us

    "contact.title": "We Are At Your Service",
    "contact.subtitle": "Drop us a line and we'll get back to you.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Type Your Message Here ...",
    "contact.sent": "Your message has been successfully sent :)",
    "contact.emailus": "Reach us via info@iwaretravel.ca",

    // ==============================in the news

    "in-the-news.title": "iWareTravel In the News",
    "in-the-news.1":
      "Latest Cohort of Junction Startups Aim to Grow Calgary's Innovation-Driven Sectors",
    "in-the-news.1date": "Oct. 03, 2019",
    "in-the-news.2": "CHAMPIONS FROM EAST TO WEST.",
    "in-the-news.2date": "Fall 2019",
    "in-the-news.3":
      "iWareTravel: Travel insurance delivered to where you start the trip.",
    "in-the-news.3date": "Fall 2019",
    "in-the-news.4": "Calgary Business Podcast - Episode 28",
    "in-the-news.4date": "Nov. 26, 2019",
    "in-the-news.5": "THE 15 STARTUPS OF ASCENSION 2020",
    "in-the-news.5date": "Feb. 18, 2020",
    "in-the-news.6": "Junction | Founders x Foundations",
    "in-the-news.6date": "Dec. 16, 2019",

    // ==============================view my policy
    "renew.title": "Renew My Policy",
    "view.title": "View My Policy",
    "view.text": "To retrieve your policy, please enter your policy number:",
    "view.policyNum": "Policy Number",
    "view.noResultPolicyNum":
      "Sorry, no result is found according to your policy number.",

    //=================================================================errors msg
    "error.nonEmpty": "Field can't be empty.",
    "error.15days": "People younger than 15 days are not eligible.",
    "error.18year": "Policy holder must be at least 18 years old.",
    "error.fname": "Please enter valid first name.",
    "error.lname": "Please enter valid last name.",
    "error.bday": "Please enter a valid date in YYYY-MM-DD format.",
    "error.bdayUnborn": "Date of birth cannot be later than current date.",
    "error.entername": "Please enter the name.",
    "error.enterPolicyNum": "Please enter a policy number.",
    "error.validEmail": "Please enter a valid email address.",
    "error.emailMatch": "Both emails have to match.",
    "error.general": "Oops, something went wrong",
    "error.province": "Please enter the 2-letter Canadian province code",

    // ============================CUSTOMIZED ERROR QUOTING MESSAGE
    "gms.dependantAge":
      "GMS requires the age of dependant to be under 19 years old",
    dependantAge: "Dependant cannot be older than 21 years old",

    "gms.olderThan80":
      "GMS does not offer plans for applicants who are 80 yrs old or older",
    "destination.olderThan80":
      "Destination does not offer plans with pre-existing condition coverage for applicants who are 80 years old or older",

    "gms.nonFamilyMember":
      "GMS does not allow non-family members (i.e. spouse and/or dependants) to be on the same policy",

    "gms.withoutPreExistingCondition":
      "GMS does not offer plans without pre-existing condition coverage",
    "tugo.withoutPreExistingCondition": "Tugo does not offer plans without pre-existing condition coverage",
    "tugoStudent.withoutPreExistingCondition": "Tugo does not offer plans without pre-existing condition coverage",
    "tugoStudent.tripCancellationCoverage": "Tugo Student Plan does not offer trip cancellation/interruption coverage",
    
    "gms.NoCoverageOrDeductible":
      "GMS does not offer options of this amount of coverage or deductible",
    
    "tugo.NoCoverageOrDeductible": "Tugo does not offer options of this amount of coverage or deductible",
    "tugoStudent.NoCoverageOrDeductible": "Tugo does not offer options of this amount of coverage or deductible",
    "tugoStudent.sportsCoverage": "Tugo Student does not provide extra sports coverage",
    "tugoStudent.travelCancellationCoverage": "Tugo Student does not provide travel cancellation/interruption coverage",    
    "destination.NoCoverageOrDeductible": "Destination does not offer options of this amount of coverage or deductible",

    "gms.travelersNum":
      "GMS does not allow the number of applicants to be greater than 6",

    "gms.sportsCoverage": "GMS does not provide extra sports coverage",
    "gms.notForQC": "Products not offered in Quebec",
    "gms.travelCancellationCoverage": "GMS does not provide travel cancellation/interruption coverage",
    "destination.sportsCoverage": "Destination does not provide extra sports coverage",
    "destination.travelCancellationCoverage": "Destination does not provide travel cancellation/interruption coverage",

    //==================================CLAIM PROCESS
    "claim.step1": "Step 1",
    "claim.step2": "Step 2",
    "claim.step3": "Step 3",
    "claim.step4": "Step 4",
    "claim.step5": "Step 5",
    "claim.step6": "Step 6",
    "claim.step7": "Step 7",
    "insurer.destin": "Destination",
    "insurer.gms": "GMS",
    "insurer.tugo": "Tugo",
    "claim.title": "claim process",
    "gms.step1.content":
      "You, or someone on your behalf, must contact GMS prior to medical treatment whenever possible.",
    "gms.step1.contact": "1.800.459.6604",
    "gms.step1.notes":
      "Failure to contact GMS within twenty-four (24) hours of receiving medical treatment or admission to hospital will limit benefits otherwise payable to 70% of eligible charges to a maximum of the sum insured.",

    "gms.step2.content":
      "A completed claim form must be submitted within ninety (90) days of the illness or injury",
    "gms.step2.contact":
      "https://www.gms.ca/Portals/0/adam/Content/dD_H3sD1zUqQo4iHpH9D7Q/Link/GMS-VTC-Emergency-Medical-Claim-Form-CA.pdf?v=2019-06-12-17-46-17",
    "gms.step2.notes": `• original itemized receipts for all bills and invoices;<br>• proof of payment by your or any other benefit plan;<br>• medical records, including a completed diagnosis by the attending physician;<br>• for dental claims, proof of the accident;<br>• proof of the travel dates including your departure date from your country of origin and visa documentation where applicable;<br>• your historical records, if requested by GMS.`,

    "gms.step3.content":
      "Attach the documents requested in the instructions section of the form as well as the original itemized bills and return to:",
    "gms.step3.contact": `Global Allianz Assistance<br>Claims Department<br>P.O. Box 277<br>Waterloo, ON<br>N2J 4A4`,
    "gms.step3.notes": `We request that you do not pay any medical fees directly to health providers unless you have been advised to do so by GMS.<br>GMS does not return receipts, so be sure to make copies of all submitted correspondence for your records.`,

    "tugo.step1.cap": "Register the Claim",
    "tugo.step1.content":
      "If hospitalized, you should call Claims at TuGo right away or as soon as possible.",
    "tugo.step1.contact": `1-800-663-0399`,

    "tugo.step2.cap": "Fill out and Return Claim Forms",
    "tugo.step2.content":
      "Your must fill out and return all claim form(s) sent to them by Claims at TuGo.",
    "tugo.step2.contact": `https://my.tugo.com/login/auth`,

    "tugo.step3.cap": "Provide Additional Documentation",
    "tugo.step3.content":
      "Your must send Claims at TuGo all additional information they ask for, such as original, itemized bills for related expenses.",
    "tugo.step3.contact": `10th Floor, 6081 No. 3 Road Richmond, BC V6Y 2B2, Canada`,
    "tugo.step3.notes": `• Itemized bills/receipts<br>• Itemized pharmacy-issued prescription drug receipts<br>• Proof of the amount paid`,

    "tugoStudent.step1.cap": "Register the Claim",
    "tugoStudent.step1.content":
      "If hospitalized, you should call Claims at TuGo right away or as soon as possible.",
    "tugoStudent.step1.contact": `1-800-663-0399`,

    "tugoStudent.step2.cap": "Fill out and Return Claim Forms",
    "tugoStudent.step2.content":
      "Your must fill out and return all claim form(s) sent to them by Claims at tugoStudent.",
    "tugoStudent.step2.contact": `https://my.tugo.com/login/auth`,

    "tugoStudent.step3.cap": "Provide Additional Documentation",
    "tugoStudent.step3.content":
      "Your must send Claims at TuGo all additional information they ask for, such as original, itemized bills for related expenses.",
    "tugoStudent.step3.contact": `10th Floor, 6081 No. 3 Road Richmond, BC V6Y 2B2, Canada`,
    "tugoStudent.step3.notes": `• Itemized bills/receipts<br>• Itemized pharmacy-issued prescription drug receipts<br>• Proof of the amount paid`,

    "destination.step1.content":
      "Contact the Assistance Centre immediately, if possible",
    "destination.step1.contact": "1-855-297-4371",
    "destination.step1.notes":
      "Your should have your policy information available. All necessary information is located on the wallet card provided to the insured upon purchase of the policy.",

    "destination.step2.content":
      "The Assistance Centre will provide guidance to get the care you need. This could range from a medical concierge service (StandbyMD), to a hospital, or to a clinic depending on the severity and nature of your emergency.",
    "destination.step2.notes":
      "https://www.google.com/maps/d/u/0/viewer?mid=14VRMXd9L6BM8Wrx63hx3tEPymf5LcoI3&ll=2.5444437451708134e-14%2C0&z=2",

    "destination.step3.content":
      "The Assistance Centre will manage your case with the hospital or clinic and work directly with them to get you stabilized.",

    "destination.step4.content":
      "Typically, after you are discharged the Assistance Centre will begin the claim adjudication process.",
    "destination.step4.notes":
      "• Original itemized bills and receipts. Be sure to keep a copy for your records.<br>• Any and all medical records/certificates, etc., given at the time of treatment that include a diagnosis, such as: a copy of the emergency room (ER) report， clinical documentation or a letter from your treating physician<br>• For hospitalization claims, we require a copy of your medical records from the treatment facility",

    "destination.step5.content":
      "During the adjudication process, the Assistance Centre will validate your eligibility, medical history, and circumstances surrounding the claim.",
    "destination.step5.contact": "Online filing of the claim form",
    "destination.step5.notes": "https://manulife.acmtravel.ca/accounts/login/",

    "destination.step6.content":
      "Once this has been completed, the Assistance Centre will adjudicate the claim and decide if it is payable or not.",

    "destination.step7.content":
      "Assuming it is payable, then the Assistance Centre will pay the medical provider directly and you will not be billed.",
    "destination.step7.contact":
      "Active Care Management, P.O. Box 1237, Station A, Windsor, ON N9A 6P8",
    "destination.step7.notes":
      "In the unlikely event that the medical provider may not have direct billing capability with the Assistance Centre, you  can easily submit their claim online at https://manulife.acmtravel.ca/accounts/login/",

    // =============================== PARTNERS
    "partners.title": "our partners",
    "partners.calgaryTour": "Calgary Tour",
    "partners.calgaryTour.text": "to be added",
    "partners.lloydSadd": "Lloyd Sadd Insurance Brokers",
    "partners.lloydSadd.text":
      "Lloyd Sadd Insurance Brokers - a parent company that owns 加怡保險; is a founding member that created Navacord; one of the biggest insurance brokerage and risk management broker alliance in Canada. We strongly believe that our clients deserve more than just a best price when it comes to insurance solution; chat with us today to find out how we can help you on home, auto, business and travel insurance needs. ",

    // ============================= BLOG
    "blog.title": "articles",
  },
}
